<!--
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-03T22:30:00+05:00
Intent: Show a read-only summary of a receipt level's rules in the campaign details, with the spend's currency and dd/mm/yy dates, and the Receipt submissions card for campaigns with a receipt level.
-->
<div class="dashboard-content" style="padding: 120px 55px 50px">

  <div class="luqta-header">
    <div class="page-heading">
      <div class="back" routerLink="/home/campaigns">
        <i class="fa-solid fa-angle-left"></i>
      </div>
      <h3>
        {{ "contestDetails.title" | translate }}
      </h3>
      <div class="copy-btns">
        <!-- Export PDF -->
        <a (click)="exportToPDF()" class="copy-link export-pdf-btn">
          <span>{{ 'contestDetails.exportPdf' | translate }}</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.83333 15H14.1667M10 5V12.5M10 12.5L7.5 10M10 12.5L12.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="1.5" y="1.5" width="17" height="17" rx="3.5" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </a>
        <span>|</span>
        <!-- Download Contest Configuration PDF -->
        <a (click)="exportConfigurationPDF()" class="copy-link export-pdf-btn">
          <span>{{ 'contestDetails.downloadConfigPdf' | translate }}</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.83333 15H14.1667M10 5V12.5M10 12.5L7.5 10M10 12.5L12.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="1.5" y="1.5" width="17" height="17" rx="3.5" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </a>
        <span *ngIf="hasSurveyLevel">|</span>
        <!-- Export Survey Responses (only shown when the contest has a survey-type level) -->
        <a *ngIf="hasSurveyLevel" nz-dropdown nzTrigger="click" [nzDropdownMenu]="surveyExportMenu"
          [class.disabled]="surveyExporting" class="copy-link export-pdf-btn">
          <span>{{ 'contestDetails.exportSurveyResponses' | translate }}</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.83333 15H14.1667M10 5V12.5M10 12.5L7.5 10M10 12.5L12.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="1.5" y="1.5" width="17" height="17" rx="3.5" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </a>
        <nz-dropdown-menu #surveyExportMenu="nzDropdownMenu">
          <ul nz-menu class="survey-export-menu">
            <li nz-menu-item (click)="exportSurveyResponses(false)">
              <strong>{{ 'contestDetails.surveyExportWithDetails' | translate }}</strong>
              <small>{{ 'contestDetails.surveyExportWithDetailsHint' | translate }}</small>
            </li>
            <li nz-menu-item (click)="exportSurveyResponses(true)">
              <strong>{{ 'contestDetails.surveyExportAnonymous' | translate }}</strong>
              <small>{{ 'contestDetails.surveyExportAnonymousHint' | translate }}</small>
            </li>
          </ul>
        </nz-dropdown-menu>
        <span *ngIf="hasValue(contests_detail?.uid)">|</span>
        <!-- Contest UID -->
        <a *ngIf="hasValue(contests_detail?.uid)" (click)="copyUID(contests_detail.uid)" class="copy-link">
          <span>{{ 'contestDetails.contest_uid' | translate }}</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_1" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
              <rect width="20" height="20" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1)">
              <path
                d="M6.66797 18.3327C6.20964 18.3327 5.81727 18.1695 5.49089 17.8431C5.1645 17.5167 5.0013 17.1243 5.0013 16.666V14.9993H3.33464C2.8763 14.9993 2.48394 14.8362 2.15755 14.5098C1.83116 14.1834 1.66797 13.791 1.66797 13.3327V11.666H3.33464V13.3327H5.0013V6.66602C5.0013 6.20768 5.1645 5.81532 5.49089 5.48893C5.81727 5.16254 6.20964 4.99935 6.66797 4.99935H13.3346V3.33268H11.668V1.66602H13.3346C13.793 1.66602 14.1853 1.82921 14.5117 2.1556C14.8381 2.48199 15.0013 2.87435 15.0013 3.33268V4.99935H16.668C17.1263 4.99935 17.5187 5.16254 17.8451 5.48893C18.1714 5.81532 18.3346 6.20768 18.3346 6.66602V16.666C18.3346 17.1243 18.1714 17.5167 17.8451 17.8431C17.5187 18.1695 17.1263 18.3327 16.668 18.3327H6.66797ZM6.66797 16.666H16.668V6.66602H6.66797V16.666ZM1.66797 9.99935V6.66602H3.33464V9.99935H1.66797ZM1.66797 4.99935V3.33268C1.66797 2.87435 1.83116 2.48199 2.15755 2.1556C2.48394 1.82921 2.8763 1.66602 3.33464 1.66602H5.0013V3.33268H3.33464V4.99935H1.66797ZM6.66797 3.33268V1.66602H10.0013V3.33268H6.66797Z"
                fill="black" />
            </g>
          </svg>
        </a>
        <span *ngIf="hasValue(contests_detail?.uid) && hasValue(contests_detail?.access_code)">|</span>
        <!-- Access Code -->
        <a *ngIf="hasValue(contests_detail?.access_code)" (click)="copyUID(contests_detail.access_code)"
          class="copy-link">
          <span>{{ 'contestDetails.access_code' | translate }}</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_2" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
              <rect width="20" height="20" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2)">
              <path
                d="M6.66797 18.3327C6.20964 18.3327 5.81727 18.1695 5.49089 17.8431C5.1645 17.5167 5.0013 17.1243 5.0013 16.666V14.9993H3.33464C2.8763 14.9993 2.48394 14.8362 2.15755 14.5098C1.83116 14.1834 1.66797 13.791 1.66797 13.3327V11.666H3.33464V13.3327H5.0013V6.66602C5.0013 6.20768 5.1645 5.81532 5.49089 5.48893C5.81727 5.16254 6.20964 4.99935 6.66797 4.99935H13.3346V3.33268H11.668V1.66602H13.3346C13.793 1.66602 14.1853 1.82921 14.5117 2.1556C14.8381 2.48199 15.0013 2.87435 15.0013 3.33268V4.99935H16.668C17.1263 4.99935 17.5187 5.16254 17.8451 5.48893C18.1714 5.81532 18.3346 6.20768 18.3346 6.66602V16.666C18.3346 17.1243 18.1714 17.5167 17.8451 17.8431C17.5187 18.1695 17.1263 18.3327 16.668 18.3327H6.66797ZM6.66797 16.666H16.668V6.66602H6.66797V16.666ZM1.66797 9.99935V6.66602H3.33464V9.99935H1.66797ZM1.66797 4.99935V3.33268C1.66797 2.87435 1.83116 2.48199 2.15755 2.1556C2.48394 1.82921 2.8763 1.66602 3.33464 1.66602H5.0013V3.33268H3.33464V4.99935H1.66797ZM6.66797 3.33268V1.66602H10.0013V3.33268H6.66797Z"
                fill="black" />
            </g>
          </svg>
        </a>
      </div>
    </div>

    <a routerLink="/home/campaigns">
      <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="47" height="47" rx="23.5" fill="#FB2A2D" />
        <mask id="mask0_40000187_6913" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="9" y="9" width="29"
          height="29">
          <rect x="9.39844" y="9.40039" width="28.2" height="28.2" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_40000187_6913)">
          <path
            d="M19.2684 28.9685L23.4984 24.7385L27.7284 28.9685L28.9666 27.7304L24.7366 23.5004L28.9666 19.2704L27.7284 18.0322L23.4984 22.2622L19.2684 18.0322L18.0303 19.2704L22.2603 23.5004L18.0303 27.7304L19.2684 28.9685ZM23.5005 34.6629C21.9565 34.6629 20.5053 34.3699 19.1468 33.784C17.7883 33.1981 16.6067 32.4029 15.6019 31.3984C14.597 30.394 13.8015 29.2129 13.2151 27.8549C12.629 26.497 12.3359 25.0462 12.3359 23.5024C12.3359 21.9585 12.6289 20.5073 13.2148 19.1488C13.8008 17.7903 14.596 16.6086 15.6004 15.6038C16.6048 14.599 17.786 13.8034 19.1439 13.2171C20.5018 12.631 21.9526 12.3379 23.4964 12.3379C25.0403 12.3379 26.4916 12.6309 27.8501 13.2168C29.2085 13.8027 30.3902 14.5979 31.395 15.6023C32.3998 16.6068 33.1954 17.7879 33.7817 19.1458C34.3679 20.5037 34.6609 21.9546 34.6609 23.4983C34.6609 25.0423 34.368 26.4935 33.782 27.852C33.1961 29.2105 32.4009 30.3922 31.3965 31.397C30.3921 32.4018 29.2109 33.1974 27.853 33.7837C26.4951 34.3698 25.0442 34.6629 23.5005 34.6629ZM23.4984 32.9004C26.1226 32.9004 28.3453 31.9898 30.1666 30.1685C31.9878 28.3473 32.8984 26.1246 32.8984 23.5004C32.8984 20.8762 31.9878 18.6535 30.1666 16.8323C28.3453 15.011 26.1226 14.1004 23.4984 14.1004C20.8743 14.1004 18.6516 15.011 16.8303 16.8323C15.0091 18.6535 14.0984 20.8762 14.0984 23.5004C14.0984 26.1246 15.0091 28.3473 16.8303 30.1685C18.6516 31.9898 20.8743 32.9004 23.4984 32.9004Z"
            fill="white" />
        </g>
      </svg>
    </a>
  </div>

  <div class="luqta-contest-detail">
    <div class="contest-detail-heading">
      <!-- Hero banner: the campaign artwork at a readable size. Left out entirely when the
           campaign has no banner (or it fails to load) rather than showing a stock image. -->
      <div class="campaign-banner-hero" *ngIf="bannerUrl">
        <img [src]="bannerUrl" alt="Campaign Banner" (error)="bannerLoadFailed = true">
      </div>

      <div class="title-heading">
        <div class="name-and-profile">
          <div class="profile" [class.profile-empty]="!bannerUrl">
            <img *ngIf="bannerUrl; else noBanner" [src]="bannerUrl" alt="Campaign Banner"
              (error)="bannerLoadFailed = true">
            <ng-template #noBanner>
              <span class="profile-initial" aria-hidden="true">{{ campaignInitial }}</span>
            </ng-template>
          </div>
          <span>
            {{ name || 'Campaign Name' }}
          </span>
        </div>
        <div class="timeline">
          <p>
            {{ 'contestDetails.timeline' | translate }} :
            <span>
              {{ getTimeRemaining(end_date_raw) }}
            </span>
          </p>
        </div>
      </div>
      <p class="disc">{{ description }}</p>
      <p *ngIf="contests_detail?.arabic_details" class="disc" dir="rtl">{{ contests_detail.arabic_details }}</p>

      <div class="submission-meta">
        <div class="submission-meta-item">
          <span class="meta-label">{{ 'contestDetails.submittedBy' | translate }}</span>
          <span class="meta-value">{{ submitted_by?.name || 'N/A' }}</span>
          <span class="meta-subvalue" *ngIf="submitted_by?.email as email">{{ email }}</span>
        </div>
        <div class="submission-meta-item">
          <span class="meta-label">{{ 'contestDetails.submittedVia' | translate }}</span>
          <span class="meta-value">{{ getSubmittedViaLabel() || 'N/A' }}</span>
        </div>
        <div class="submission-meta-item">
          <span class="meta-label">{{ 'contestDetails.submittedOn' | translate }}</span>
          <span class="meta-value">{{ submitted_on || 'N/A' }}</span>
        </div>
        <div class="submission-meta-item">
          <span class="meta-label">{{ 'common.status' | translate }}</span>
          <span [class]="getStatusBadgeClass(contests_detail?.status)">{{ getStatusLabel(contests_detail?.status) }}</span>
        </div>
        <div class="submission-meta-item">
          <span class="meta-label">{{ (isRejected ? 'contestDetails.rejectedBy' : 'contestDetails.approvedBy') | translate }}</span>
          <span class="meta-value">{{ approved_by?.name || ('contestDetails.notYetApproved' | translate) }}</span>
          <span class="meta-subvalue" *ngIf="approved_by?.email as email">{{ email }}</span>
        </div>
        <div class="submission-meta-item" *ngIf="isWebQrCampaign">
          <span class="meta-label">{{ 'addContests.kycTier.label' | translate }}</span>
          <span class="meta-value" nz-tooltip [nzTooltipTitle]="('addContests.kycTier.' + kycTier + 'Tooltip') | translate">
            {{ ('addContests.kycTier.' + kycTier) | translate }}
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Dynamic Levels -->
      <div class="col-lg-6" *ngFor="let level of levels_of_contest; let i = index">
        <div class="contest-detail-card">
          <div class="card-heading">
            <div class="title">
              <h5>
                {{ level.name || (('contestDetails.levels.level' | translate) + ' ' + (i + 1)) }}
              </h5>
              <p>{{ 'contestDetails.timeRemaining' | translate }}: {{ getTimeRemaining(level.level_timeline) }}</p>
            </div>
            <div class="d-flex align-items-center gap-2">
              <a class="copy-id-btn" role="button" tabindex="0" [title]="'contestDetails.copyLevelUid' | translate"
                [attr.aria-label]="'contestDetails.copyLevelUid' | translate"
                (click)="LevelUID(level.uid)" (keydown.enter)="LevelUID(level.uid)">
                <i class="fa-solid fa-copy"></i>
              </a>
              <a class="edit" role="button" tabindex="0" *ngIf="isContestEditable()"
                (click)="toggleEditLevel(level.id, level)" (keydown.enter)="toggleEditLevel(level.id, level)">
                {{ isEditingLevel(level.id) ? ('common.cancel' | translate) : getEditButtonText(level) }}
              </a>
            </div>
          </div>

          <!-- Edit Mode -->
          <div *ngIf="isEditingLevel(level.id) && getLevelForm(level.id) as levelForm" [formGroup]="levelForm"
            class="w-100">

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="">
                    {{ 'contestDetails.description2' | translate }}<span class="text-danger">*</span>
                    <span nz-tooltip nzTooltipTitle="{{ 'Levels_Array.Level_description_tooltip' | translate }}" nzTooltipPlacement="top">
                      <i class="fa-solid fa-circle-info info ms-1"></i>
                    </span>
                  </label>
                  <textarea class="form-control" rows="3" formControlName="description"></textarea>
                  <small class="error text-danger" *ngIf="levelForm.get('description')?.touched && levelForm.get('description')?.invalid">
                    {{ 'addContestsValidation.required' | translate }}
                  </small>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="">
                    {{ 'addContests.arabicDescription.label' | translate }}<span class="text-danger">*</span>
                    <span nz-tooltip nzTooltipTitle="{{ 'addContests.arabicDescription.level_tooltip' | translate }}" nzTooltipPlacement="top">
                      <i class="fa-solid fa-circle-info info ms-1"></i>
                    </span>
                  </label>
                  <textarea class="form-control" rows="3" formControlName="arabic_description" dir="rtl"></textarea>
                  <small class="error text-danger" *ngIf="levelForm.get('arabic_description')?.touched && levelForm.get('arabic_description')?.invalid">
                    {{ 'addContestsValidation.required' | translate }}
                  </small>
                </div>
              </div>
            </div>

            <!-- Survey Edit Fields -->
            <div *ngIf="level.level_type === 'survey'" class="row mb-3">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="">
                    {{ 'add-content.min-answers' | translate }}<span class="text-danger">*</span>
                    <span nz-tooltip nzTooltipTitle="{{ 'add-content.min-answers-tooltip' | translate }}" nzTooltipPlacement="top">
                      <i class="fa-solid fa-circle-info info ms-1"></i>
                    </span>
                  </label>
                  <input type="number" class="form-control" formControlName="min_answers_required"
                    [min]="getSurveyRequiredCount(level)" [max]="level.survey_questions?.length || 1" />
                  <small class="error text-danger d-block mt-1" *ngIf="levelForm.get('min_answers_required')?.touched && levelForm.get('min_answers_required')?.errors?.['max']">
                    Value cannot exceed the total number of questions ({{ level.survey_questions?.length || 0 }}).
                  </small>
                  <small class="error text-danger d-block mt-1" *ngIf="levelForm.get('min_answers_required')?.touched && levelForm.get('min_answers_required')?.errors?.['min']">
                    <ng-container *ngIf="getSurveyRequiredCount(level) > 1; else minOne">
                      Minimum answers required cannot be less than the number of required questions ({{ getSurveyRequiredCount(level) }}).
                    </ng-container>
                    <ng-template #minOne>Minimum answers required must be at least 1.</ng-template>
                  </small>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="">
                    {{ 'add-content.question-order' | translate }}
                    <span nz-tooltip nzTooltipTitle="{{ 'add-content.question-order-tooltip' | translate }}" nzTooltipPlacement="top">
                      <i class="fa-solid fa-circle-info info ms-1"></i>
                    </span>
                  </label>
                  <nz-select class="form-control-qr w-100" formControlName="question_order" nzSize="large" [nzOptionOverflowSize]="5">
                    <nz-option nzValue="fixed" [nzLabel]="'add-content.order-fixed' | translate"></nz-option>
                    <nz-option nzValue="randomized" [nzLabel]="'add-content.order-randomized' | translate"></nz-option>
                  </nz-select>
                </div>
              </div>
            </div>

            <!-- Link Task Edit Fields -->
            <div *ngIf="level.level_type === 'link_task'" class="row mb-3">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="">
                    {{ 'add-content.task-instruction' | translate }}<span class="text-danger">*</span>
                    <span nz-tooltip nzTooltipTitle="{{ 'add-content.task-instruction-tooltip' | translate }}" nzTooltipPlacement="top">
                      <i class="fa-solid fa-circle-info info ms-1"></i>
                    </span>
                  </label>
                  <input type="text" class="form-control" formControlName="link_task_instruction" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label [attr.for]="'detail-link-task-instruction-ar-' + level.id">
                    {{ 'add-content.task-instruction-ar' | translate }}
                  </label>
                  <input type="text" class="form-control" formControlName="link_task_instruction_ar"
                    [id]="'detail-link-task-instruction-ar-' + level.id" dir="rtl" lang="ar"
                    [placeholder]="'add-content.task-instruction-ar-placeholder' | translate" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="">
                    {{ 'add-content.task-url' | translate }}<span class="text-danger">*</span>
                    <span nz-tooltip nzTooltipTitle="{{ 'add-content.task-url-tooltip' | translate }}" nzTooltipPlacement="top">
                      <i class="fa-solid fa-circle-info info ms-1"></i>
                    </span>
                  </label>
                  <input type="text" class="form-control" formControlName="link_task_url" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label for="">
                    {{ 'add-content.timer-duration' | translate }}
                    <span nz-tooltip nzTooltipTitle="{{ 'add-content.timer-duration-tooltip' | translate }}" nzTooltipPlacement="top">
                      <i class="fa-solid fa-circle-info info ms-1"></i>
                    </span>
                  </label>
                  <input type="number" class="form-control" formControlName="link_task_timer" />
                </div>
              </div>
            </div>

            <!-- Type-specific fields -->
            <div *ngIf="level.level_type === 'text'" class="form-group">
              <label for="">📄 {{ 'contestDetails.textContent' | translate }}:<span class="text-danger">*</span></label>

              <!-- Loop through textContent FormArray -->
              <div *ngFor="let textControl of getTextContents(level.id).controls; let j = index" class="mb-2">
                <div class="d-flex gap-2 align-items-start">
                  <div class="flex-grow-1">
                    <input type="text" class="form-control" [formControl]="$any(textControl)"
                      [placeholder]="'contestDetails.enterTextContent' | translate" maxlength="1000" />

                    <!-- Character counter -->
                    <div class="d-flex justify-content-end mt-1">
                      <div class="character-counter">
                        <small [ngClass]="{
                          'text-danger': (textControl.value?.length || 0) === 1000,
                          'text-dark': (textControl.value?.length || 0) < 1000
                        }">
                          {{ textControl.value?.length || 0 }}/1000
                        </small>
                      </div>
                    </div>

                    <small class="text-danger" *ngIf="textControl?.invalid && textControl?.touched">
                      {{ 'contestDetails.textContentRequired' | translate }}
                    </small>
                  </div>

                  <!-- Remove button (only show if more than one text field) -->
                  <button type="button" class="btn btn-trash " *ngIf="getTextContents(level.id).length > 1"
                    (click)="removeTextContent(level.id, j)" style="margin-top: 0;">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

              <!-- Add Text button -->
              <button type="button" class="btn btn-sm btn-primary mt-2" (click)="addTextContent(level.id)">
                <i class="fa fa-plus"></i> {{ 'contestDetails.addText' | translate }}
              </button>
            </div>

            <div *ngIf="level.level_type === 'qr'" class="form-group">
              <label for="">{{ 'contestDetails.qrCodeData' | translate }}</label>
              <input type="text" class="form-control" formControlName="qrData" />
              <div *ngIf="levelForm.get('qrData')?.value" class="qr mt-2">
                <qrcode [qrdata]="levelForm.get('qrData')?.value" [width]="200" [errorCorrectionLevel]="'M'"
                  [allowEmptyString]="true"></qrcode>
              </div>
            </div>

            <div *ngIf="level.level_type === 'image'" class="form-group">
              <label for="">🖼️ {{ 'contestDetails.uploadImage' | translate }}:<span class="text-danger">*</span></label>
              <div class="position-relative">
                <input type="text" [id]="'imageDisplay_' + level.id" class="form-control"
                  [value]="levelImagePreviews[level.id] ? ('contestDetails.image' | translate) : ''" [placeholder]="'contestDetails.uploadImage' | translate" readonly
                  style="padding-right: 120px; cursor: pointer;"
                  (click)="levelImagePreviews[level.id] ? showImageModal(level.id) : triggerLevelImageInput(level.id)" />
                <input type="file" [id]="'imageFile_' + level.id" class="form-control d-none" accept=".png, .jpg, .jpeg"
                  (change)="onLevelImageSelected($event, level.id)" />
                <button type="button" class="btn btn-dark position-absolute"
                  (click)="levelImagePreviews[level.id] ? showImageModal(level.id) : triggerLevelImageInput(level.id)"
                  style="top: 50%; right: 5px; transform: translateY(-50%); font-size:14px; padding: 4px 9px;">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21 12V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M16 7L12 3M12 3L8 7M12 3V15"
                      stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  {{ levelImagePreviews[level.id] ? ('contestDetails.image' | translate) : ('contestDetails.upload' | translate) }}
                </button>
              </div>
              <small class="text-danger"
                *ngIf="levelForm.get('imageFile')?.invalid && levelForm.get('imageFile')?.touched && !levelImagePreviews[level.id]">
                {{ 'contestDetails.imageRequired' | translate }}
              </small>

              <!-- Image Preview below upload field -->
              <div *ngIf="levelImagePreviews[level.id]" class="mt-3 text-center">




                <img [src]="levelImagePreviews[level.id]" alt="Image Preview" class="img-fluid rounded border banner"
                  style=" object-fit: cover; cursor: pointer;" (click)="showImageModal(level.id)" />
                <p class="text-muted mt-1 mb-0"><small>{{ 'contestDetails.clickImageEnlarge' | translate }}</small></p>
              </div>
            </div>

            <div *ngIf="level.level_type === 'client_webhook'">
              <div class="form-group">
                <label for="">🌐 {{ 'contestDetails.clientWebhookUrl' | translate }}</label>
                <input type="url" class="form-control" formControlName="client_webhook_url"
                  [placeholder]="'contestDetails.enterClientWebhookUrl' | translate" />
              </div>

              <!-- Client Variables -->
              <div class="form-group">
                <label for="">⚙️ {{ 'contestDetails.clientVariables' | translate }}</label>
                <button type="button" class="btn btn-dark mb-3 w-100" (click)="addVariable(level.id)">
                  <i class="fa fa-plus"></i> {{ 'contestDetails.addVariable' | translate }}
                </button>

                <div formArrayName="client_variables" class="client-variables">
                  <div class="mb-2" *ngFor="let variable of getClientVariables(level.id)?.controls; let j = index"
                    [formGroupName]="j">
                    <div class="row">
                      <div class="col-md-4">
                        <input class="form-control" formControlName="variable_name" [placeholder]="'contestDetails.variableName' | translate" />
                        <small class="text-danger"
                          *ngIf="variable.get('variable_name')?.invalid && variable.get('variable_name')?.touched">
                          {{ 'contestDetails.required' | translate }}
                        </small>
                      </div>
                      <div class="col-md-4">
                        <input class="form-control" formControlName="display_name" [placeholder]="'contestDetails.displayName' | translate" />
                        <small class="text-danger"
                          *ngIf="variable.get('display_name')?.invalid && variable.get('display_name')?.touched">
                          {{ 'contestDetails.required' | translate }}
                        </small>
                      </div>
                      <div class="col-md-3">
                        <nz-select class="custom-select" formControlName="datatype" [nzPlaceHolder]="'contestDetails.selectDatatype' | translate"
                          nzSize="large" [nzOptionOverflowSize]="5">
                          <nz-option nzValue="string" [nzLabel]="'contestDetails.datatypeString' | translate"></nz-option>
                          <nz-option nzValue="number" [nzLabel]="'contestDetails.datatypeNumber' | translate"></nz-option>
                          <nz-option nzValue="boolean" [nzLabel]="'contestDetails.datatypeBoolean' | translate"></nz-option>
                          <nz-option nzValue="date" [nzLabel]="'contestDetails.datatypeDate' | translate"></nz-option>
                          <nz-option nzValue="datetime" [nzLabel]="'contestDetails.datatypeDateTime' | translate"></nz-option>
                          <nz-option nzValue="float" [nzLabel]="'contestDetails.datatypeFloat' | translate"></nz-option>
                          <nz-option nzValue="double" [nzLabel]="'contestDetails.datatypeDouble' | translate"></nz-option>
                        </nz-select>

                      </div>
                      <div class="col-md-1">
                        <button type="button" class="btn btn-trash w-100" (click)="removeVariable(level.id, j)">
                          <i class="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="level.level_type === 'luqta_weebhook'" class="form-group">
              <label for="">🌐 {{ 'contestDetails.luqtaWebhookUrl' | translate }}</label>
              <input type="url" class="form-control"
                [value]="luqtaWebhookUrl"
                readonly disabled />
              <small class="text-muted">{{ 'contestDetails.systemDefinedWebhook' | translate }}</small>
            </div>

            <div *ngIf="level.level_type === 'quiz'" class="form-group" [formGroup]="levelForms[level.id]">
              <label for="">📝 {{ 'contestDetails.selectQuiz' | translate }}</label>
              <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'contestDetails.selectAQuiz' | translate" class="form-control-qr w-100"
                [nzOptionHeightPx]="40" [nzOptionOverflowSize]="5"
                formControlName="quizzes_id" (nzOpenChange)="onQuizDropdownOpen($event)">
                <nz-option *ngFor="let quiz of quizzesList" [nzLabel]="quiz.quiz_title" [nzValue]="quiz.id"></nz-option>
              </nz-select>
            </div>

            <button class="btn btn-primary w-100 mt-3" (click)="saveLevel(level.id, level)">
              <i class="fa fa-save"></i> {{ 'contestDetails.saveChanges' | translate }}
            </button>
          </div>

          <!-- Image Preview Modal -->
          <nz-modal *ngIf="level.level_type === 'image'" [(nzVisible)]="isImageModalVisible[level.id]"
            [nzTitle]="'contestDetails.imagePreview' | translate" (nzOnCancel)="handleImageCancel(level.id)" [nzClassName]="'ImageModal'"
            [nzFooter]="null" [nzWidth]="600">
            <ng-container *nzModalContent>
              <div class="text-center">
                <!-- Image Preview - Full Width -->
                <img *ngIf="levelImagePreviews[level.id]" [src]="levelImagePreviews[level.id]" alt="Level Image"
                  class="img-fluid" style="width: 100%; max-height: 400px; object-fit: contain;" />
              </div>

              <!-- Buttons Row - Equal Width -->
              <div class="d-flex gap-2 mt-3">
                <!-- Re-upload button -->
                <button type="button" class="btn btn-primary" style="flex: 1;"
                  (click)="triggerLevelImageInput(level.id)">
                  <i class="fa fa-upload"></i> {{ 'contestDetails.reuploadImage' | translate }}
                </button>

                <!-- Download button -->
                <button type="button" class="btn btn-dark" style="flex: 1; background-color: #2E3B55; border-color: #2E3B55;"
                  (click)="downloadLevelImage(level.id, level)">
                  <i class="fa fa-download"></i> Download Image
                </button>

                <!-- Save Image button -->
                <button type="button" class="btn btn-success" style="flex: 1;"
                  (click)="saveImageAndShowPreview(level.id, level)">
                  <i class="fa fa-save"></i> {{ 'contestDetails.saveImage' | translate }}
                </button>
              </div>
            </ng-container>
          </nz-modal>

          <!-- View Mode -->
          <div *ngIf="!isEditingLevel(level.id)" class="w-100">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="">{{ 'contestDetails.description2' | translate }}</label>
                  <p class="text-secondary campaign-plain-text">{{ level.description }}</p>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="">{{ 'addContests.arabicDescription.label' | translate }}</label>
                  <p class="text-secondary campaign-plain-text" dir="rtl">{{ level.arabic_description || 'N/A' }}</p>
                </div>
              </div>
            </div>

            <div *ngIf="level.level_type === 'text'" class="form-group">
              <label for="">📄 {{ 'contestDetails.textContent' | translate }}:</label>
              <div *ngFor="let textItem of splitTextContent(level.textContent); let i = index" class="mb-2">
                <label for="">{{ 'contestDetails.textN' | translate: { n: i + 1 } }}:</label>
                <p class="text-secondary mb-0 campaign-plain-text">{{ textItem }}</p>
              </div>
              <div *ngIf="!level.textContent || level.textContent.trim() === ''" class="text-muted">
                {{ 'contestDetails.noTextContent' | translate }}
              </div>
            </div>

            <div *ngIf="level.level_type === 'qr'" class="form-group">
              <label for="">{{ 'contestDetails.qrCode' | translate }}</label>
              <div class="qr" *ngIf="level.qrData">
                <qrcode [qrdata]="level.qrData" [errorCorrectionLevel]="'M'" [allowEmptyString]="true"></qrcode>
              </div>
              <p *ngIf="!level.qrData" class="text-muted">{{ 'contestDetails.noQrCodeData' | translate }}</p>
            </div>

            <div *ngIf="level.level_type === 'image'" class="form-group">
              <label for="">🖼️ {{ 'contestDetails.image' | translate }}</label>
              <div class="banner" *ngIf="level.image">
                <img [src]="level.image.url || level.image.path || level.image" alt="Level Image" />
              </div>
              <div>

              </div>
              <p *ngIf="!level.image" class="text-muted">{{ 'contestDetails.noImageUploaded' | translate }}</p>
            </div>

            <div *ngIf="level.level_type === 'client_webhook'" class="w-100">
              <div class="form-group">
                <label for="">🌐 {{ 'contestDetails.clientWebhookUrl' | translate }}</label>
                <p class="text-secondary">{{ level.client_webhook_url }}</p>
              </div>

              <!-- Client Variables Display -->
              <div class="form-group" *ngIf="level.client_variables && level.client_variables.length > 0">
                <label for="">⚙️ {{ 'contestDetails.variablesCount' | translate: { count: level.client_variables.length } }}</label>
                <div class="row">
                  <div class="col-md-6 mb-2" *ngFor="let variable of getDisplayedVariables(level)">
                    <div class="border rounded p-2">
                      <strong class="text-dark d-block">{{ variable.display_name }}</strong>
                      <small class="text-muted">{{ variable.variable_name }} : {{ variable.datatype }}</small>
                    </div>
                  </div>
                </div>

                <!-- Show More/Less buttons -->
                <div *ngIf="shouldShowMore(level)" class="text-center mt-2">
                  <button class="btn btn-primary w-100" (click)="toggleVariablesDisplay(level.id)">
                    {{ 'contestDetails.moreCount' | translate: { count: getRemainingVariablesCount(level) } }}
                  </button>
                </div>
                <div *ngIf="shouldShowLess(level)" class="text-center mt-2">
                  <button class="btn btn-danger" style="width: 200px;" (click)="toggleVariablesDisplay(level.id)">
                    {{ 'contestDetails.showLess' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="level.level_type === 'luqta_weebhook'" class="form-group">
              <label for="">🌐 {{ 'contestDetails.luqtaWebhookUrl' | translate }}</label>
              <p class="text-secondary text-success fw-semibold">{{ luqtaWebhookUrl }}</p>
              <small class="text-muted">{{ 'contestDetails.systemDefinedWebhookShort' | translate }}</small>
            </div>

            <!-- Survey level details view -->
            <div *ngIf="level.level_type === 'survey'" class="form-group">
              <label for="">📝 {{ 'add-content.survey-level' | translate }} ({{ 'add-content.min-answers' | translate }}: {{ level.min_answers_required || 1 }}):</label>
              <div *ngFor="let q of level.survey_questions || []; let qi = index" class="border rounded p-3 mb-2" style="background:#f8fafc;">
                <strong>Q{{ qi + 1 }}: {{ isArabic ? (q.arabic_question_text || q.question_text) : q.question_text }}</strong>
                <span class="badge bg-secondary ms-2" style="font-size: 10px;">{{ q.question_type === 'mcq' ? ('add-content.mcq' | translate) : ('add-content.open-text' | translate) }}</span>
                <div *ngIf="q.question_type === 'mcq'" class="mt-2" style="margin-inline-start: 15px;">
                  <ul class="mb-0">
                    <li *ngFor="let opt of q.options || []">
                      {{ isArabic ? (opt.arabic_option_text || opt.option_text) : opt.option_text }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Link Task level details view -->
            <div *ngIf="level.level_type === 'link_task'" class="form-group">
              <label for="">🔗 {{ 'add-content.link-task-level' | translate }}:</label>
              <p class="text-secondary mb-1"><b>{{ 'add-content.task-instruction' | translate }}:</b> {{ level.link_task_instruction }}</p>
              <p *ngIf="getLinkTaskInstructionAr(level)" class="text-secondary mb-1" dir="rtl" lang="ar"><b>{{ 'add-content.task-instruction-ar' | translate }}:</b> {{ getLinkTaskInstructionAr(level) }}</p>
              <p class="text-secondary mb-1"><b>{{ 'add-content.task-url' | translate }}:</b> <a [href]="level.link_task_url" target="_blank">{{ level.link_task_url }}</a></p>
              <p class="text-secondary mb-0"><b>{{ 'add-content.timer-duration' | translate }}:</b> {{ level.link_task_timer || 0 }}s</p>
            </div>

            <!-- Receipt level details view -->
            <div *ngIf="level.level_type === 'receipt'" class="form-group">
              <label for="">🧾 {{ 'contestDetails.levelTypes.receipt' | translate }}:</label>
              <ng-container *ngIf="receiptRulesOf(level) as rules; else noReceiptRules">
                <p class="text-secondary mb-1">
                  <b>{{ 'add-content.receipt.retailers' | translate }}:</b>
                  {{ rules.retailers?.length ? rules.retailers.join(', ') : ('add-content.receipt.any-shop' | translate) }}
                </p>
                <p class="text-secondary mb-1">
                  <b>{{ 'add-content.receipt.products' | translate }}:</b>
                  {{ rules.products?.length ? receiptProductNames(rules) : ('add-content.receipt.any-purchase' | translate) }}
                  <ng-container *ngIf="rules.products?.length > 1">
                    ({{ (rules.combination_mode === 'all' ? 'add-content.receipt.combination-all' : 'add-content.receipt.combination-any') | translate }})
                  </ng-container>
                </p>
                <p *ngIf="rules.min_quantity > 0" class="text-secondary mb-1">
                  <b>{{ 'add-content.receipt.min-quantity' | translate }}:</b> {{ rules.min_quantity }}
                </p>
                <p *ngIf="rules.min_spend > 0" class="text-secondary mb-1">
                  <b>{{ 'add-content.receipt.min-spend' | translate }}:</b> {{ rules.min_spend }} {{ receiptCurrencyLabel(rules) }}
                  ({{ (rules.spend_basis === 'qualifying_items' ? 'add-content.receipt.basis-items' : 'add-content.receipt.basis-total') | translate }})
                </p>
                <p *ngIf="rules.purchase_from || rules.purchase_to" class="text-secondary mb-1">
                  <b>{{ 'add-content.receipt.purchase-window' | translate }}:</b>
                  {{ receiptDay(rules.purchase_from) }} – {{ receiptDay(rules.purchase_to) }}
                </p>
                <p class="text-secondary mb-0">
                  <b>{{ 'add-content.receipt.max-attempts' | translate }}:</b> {{ rules.max_attempts || 3 }}
                </p>
              </ng-container>
              <ng-template #noReceiptRules>
                <p class="text-muted mb-0">{{ 'add-content.receipt.no-rules' | translate }}</p>
              </ng-template>
            </div>

            <div *ngIf="level.level_type === 'quiz'" class="form-group">
              <label for="">📝 {{ 'contestDetails.quiz' | translate }}</label>
              <p class="text-secondary fw-semibold" *ngIf="level.quizzes_id">
                {{ level._quizzes?.quiz_title || getQuizTitle(level.quizzes_id) }}
              </p>
              <p class="text-muted" *ngIf="!level.quizzes_id">{{ 'contestDetails.noQuizSelected' | translate }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Prize Cards -->
      <div class="col-lg-6" *ngFor="let prize of _contest_prize || []">
        <div class="contest-detail-card">
          <div class="banner" [class.banner-empty]="!prizeImageUrl(prize)">
            <img *ngIf="prizeImageUrl(prize); else noPrizeImage" [src]="prizeImageUrl(prize)" alt="Prize Image"
              (error)="failedPrizeImages.add(prizeImageUrl(prize))">
            <ng-template #noPrizeImage>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="8" width="18" height="4" rx="1" />
                <path d="M12 8v13" />
                <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
                <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
              </svg>
              <span>{{ 'contestDetails.noPrizeImage' | translate }}</span>
            </ng-template>
          </div>
          <div class="card-heading">
            <div class="title prize-timeline-wrap">
              <div class="prize-timeline">
                <span class="timeline-label">{{ 'contestDetails.timeline' | translate }}</span>
                <span>{{ 'contestDetails.startingDate' | translate }}: {{ start_date }}</span>
                <span>{{ 'contestDetails.endingDate' | translate }}: {{ end_date }}</span>
              </div>
              <div class="draw-date-row">{{ 'contestDetails.drawDate' | translate }}: {{ draw_date || 'N/A' }}</div>
              <div *ngIf="contests_detail?.draw_type" class="draw-type-row" style="margin-top: 6px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                <span style="font-size: 13px; color: #555;">{{ 'contestDetails.drawType' | translate }}:</span>
                <span class="badge"
                  [ngStyle]="{'background': contests_detail.draw_type === 'top_points' ? '#6D28D9' : contests_detail.draw_type === 'first_to_complete' ? '#0EA5E9' : '#6B7280', 'color': 'white', 'padding': '4px 10px', 'border-radius': '12px', 'font-size': '12px'}">
                  {{ getDrawTypeLabel() }}
                </span>
                <span *ngIf="getTieBreakingRule()" style="font-size: 11px; color: #888; font-style: italic;">{{ getTieBreakingRule() }}</span>
              </div>
            </div>
          </div>
          <div class="form-group prize-meta">
            <p>{{ 'contestDetails.values' | translate }}: <b>{{prize.value}} {{prize.currency || 'USD'}}</b></p>
            <p>{{ 'contestDetails.prizeName' | translate }}: <b>{{ getPrizeDisplayName(prize) }}</b></p>
            <p *ngIf="isArabic && prize.name && getPrizeDisplayName(prize) !== prize.name" class="text-muted" style="font-size: 12px;">
              {{ prize.name }}
            </p>
            <p *ngIf="!isArabic && (prize.arabic_prize_name || prize.arabic_name)" class="text-muted" style="font-size: 12px;" dir="rtl">
              {{ prize.arabic_prize_name || prize.arabic_name }}
            </p>
            <p>{{ 'contestDetails.numberOfWinners' | translate }}: <b>{{ contests_detail?.number_of_winners ?? 'N/A' }}</b></p>
          </div>

          <!-- Uploaded codes of a "unique code per winner" gift card -->
          <section class="gift-card-codes" *ngIf="isGiftCardCodePrize(prize)"
            [attr.aria-label]="'contestDetails.giftCardCodes.title' | translate">
            <div class="gift-card-codes__head">
              <h4 class="gift-card-codes__title">{{ 'contestDetails.giftCardCodes.title' | translate }}</h4>
              <span class="gift-card-codes__summary" *ngIf="giftCardPoolOf(prize) as pool">
                {{ 'contestDetails.giftCardCodes.summary' | translate: { total: pool.total, claimed: pool.claimed } }}
              </span>
            </div>

            <p class="gift-card-codes__note" *ngIf="giftCardCodesLoading">
              {{ 'contestDetails.giftCardCodes.loading' | translate }}
            </p>
            <p class="gift-card-codes__note is-error" *ngIf="!giftCardCodesLoading && giftCardCodesFailed">
              {{ 'contestDetails.giftCardCodes.loadFailed' | translate }}
            </p>

            <ng-container *ngIf="!giftCardCodesLoading && !giftCardCodesFailed">
              <ng-container *ngIf="giftCardPoolOf(prize) as pool; else noGiftCardCodes">
                <ul class="gift-card-codes__list" *ngIf="pool.codes.length; else noGiftCardCodes">
                  <li *ngFor="let code of pool.codes; trackBy: trackGiftCardCode" class="gift-card-codes__row">
                    <code class="gift-card-codes__code" dir="ltr">{{ code.code }}</code>
                    <span [ngClass]="giftCardStatusClass(code.status)">
                      {{ 'contestDetails.giftCardCodes.status.' + code.status | translate }}
                    </span>
                    <button type="button" class="gift-card-codes__copy" (click)="copyGiftCardCode(code.code)"
                      [attr.aria-label]="'contestDetails.giftCardCodes.copy' | translate"
                      nz-tooltip [nzTooltipTitle]="'contestDetails.giftCardCodes.copy' | translate">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <rect x="9" y="9" width="13" height="13" rx="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                      </svg>
                    </button>
                  </li>
                </ul>
              </ng-container>
              <ng-template #noGiftCardCodes>
                <p class="gift-card-codes__note">
                  {{ (giftCardPoolOf(prize)?.total && !giftCardPoolOf(prize)?.listed
                    ? 'contestDetails.giftCardCodes.notListed'
                    : 'contestDetails.giftCardCodes.empty') | translate }}
                </p>
              </ng-template>
            </ng-container>
          </section>
        </div>
      </div>
    </div>
  </div>

  <!-- Contest Performance Section -->
  <div class="luqta-card">
    <div class="card-heading"
      style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
      <h3>{{ 'contestDetails.engagementPerformance' | translate }}
        <span nz-tooltip [nzTooltipTitle]="'contestDetails.engagementPerformanceTooltip' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center; margin-inline-start: 4px;">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_perf" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
              <rect width="14" height="14" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_perf)">
              <path
                d="M6.41797 9.91602H7.58464V6.41602H6.41797V9.91602ZM7.0013 5.24935C7.16658 5.24935 7.30512 5.19345 7.41693 5.08164C7.52873 4.96984 7.58464 4.83129 7.58464 4.66602C7.58464 4.50074 7.52873 4.3622 7.41693 4.25039C7.30512 4.13859 7.16658 4.08268 7.0013 4.08268C6.83602 4.08268 6.69748 4.13859 6.58568 4.25039C6.47387 4.3622 6.41797 4.50074 6.41797 4.66602C6.41797 4.83129 6.47387 4.96984 6.58568 5.08164C6.69748 5.19345 6.83602 5.24935 7.0013 5.24935ZM7.0013 12.8327C6.19436 12.8327 5.43602 12.6796 4.7263 12.3733C4.01658 12.0671 3.39922 11.6514 2.87422 11.1264C2.34922 10.6014 1.93359 9.98407 1.62734 9.27435C1.32109 8.56463 1.16797 7.80629 1.16797 6.99935C1.16797 6.1924 1.32109 5.43407 1.62734 4.72435C1.93359 4.01463 2.34922 3.39727 2.87422 2.87227C3.39922 2.34727 4.01658 1.93164 4.7263 1.62539C5.43602 1.31914 6.19436 1.16602 7.0013 1.16602C7.80825 1.16602 8.56658 1.31914 9.2763 1.62539C9.98602 1.93164 10.6034 2.34727 11.1284 2.87227C11.6534 3.39727 12.069 4.01463 12.3753 4.72435C12.6815 5.43407 12.8346 6.1924 12.8346 6.99935C12.8346 7.80629 12.6815 8.56463 12.3753 9.27435C12.069 9.98407 11.6534 10.6014 11.1284 11.1264C10.6034 11.6514 9.98602 12.0671 9.2763 12.3733C8.56658 12.6796 7.80825 12.8327 7.0013 12.8327ZM7.0013 11.666C8.30408 11.666 9.40755 11.2139 10.3117 10.3098C11.2159 9.4056 11.668 8.30213 11.668 6.99935C11.668 5.69657 11.2159 4.5931 10.3117 3.68893C9.40755 2.78477 8.30408 2.33268 7.0013 2.33268C5.69852 2.33268 4.59505 2.78477 3.69089 3.68893C2.78672 4.5931 2.33464 5.69657 2.33464 6.99935C2.33464 8.30213 2.78672 9.4056 3.69089 10.3098C4.59505 11.2139 5.69852 11.666 7.0013 11.666Z"
                fill="#7A7A7A" />
            </g>
          </svg>
        </span>
      </h3>
      <div style="display: flex; align-items: center; gap: 8px;">
        <div style="position: relative;">
          <button class="btn btn-date" (click)="performancePickerOpen = !performancePickerOpen">
            <span>{{ performanceDateRange.length === 2 ? (formatDateToString(performanceDateRange[0]) + ' - ' +
              formatDateToString(performanceDateRange[1])) : ('common.all-time' | translate) }}</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_perf_date" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
                height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_perf_date)">
                <path
                  d="M5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V6.30777C3.5 5.8026 3.675 5.37502 4.025 5.02502C4.375 4.67502 4.80258 4.50002 5.30775 4.50002H6.69225V3.15377C6.69225 2.9346 6.76567 2.7516 6.9125 2.60477C7.05933 2.4581 7.24233 2.38477 7.4615 2.38477C7.68083 2.38477 7.86383 2.4581 8.0105 2.60477C8.15733 2.7516 8.23075 2.9346 8.23075 3.15377V4.50002H15.8077V3.13477C15.8077 2.92193 15.8795 2.74368 16.023 2.60002C16.1667 2.45652 16.3449 2.38477 16.5577 2.38477C16.7706 2.38477 16.9487 2.45652 17.0922 2.60002C17.2359 2.74368 17.3077 2.92193 17.3077 3.13477V4.50002H18.6923C19.1974 4.50002 19.625 4.67502 19.975 5.02502C20.325 5.37502 20.5 5.8026 20.5 6.30777V19.6923C20.5 20.1974 20.325 20.625 19.975 20.975C19.625 21.325 19.1974 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9038C18.9679 19.8398 19 19.7693 19 19.6923V10.3078H5V19.6923C5 19.7693 5.03208 19.8398 5.09625 19.9038C5.16025 19.9679 5.23075 20 5.30775 20Z"
                  fill="#1E005E" />
              </g>
            </svg>
          </button>
          <div *ngIf="performancePickerOpen"
            style="position: absolute; top: 45px; right: 0; z-index: 1000; background: white; padding: 10px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
            <nz-range-picker [(ngModel)]="performanceDateRange"
              (ngModelChange)="onPerformanceDateChange($event); performancePickerOpen = false"
              [nzPlaceHolder]="[('contestDetails.startDate' | translate), ('contestDetails.endDate' | translate)]" nzFormat="dd-MM-yyyy"
              style="width: 280px;"></nz-range-picker>
          </div>
        </div>
      </div>
    </div>
    <p class="text-muted mb-0" *ngIf="performanceLoading">{{ 'contestDetails.loadingPerformance' | translate }}</p>
    <p class="text-danger mb-0" *ngIf="performanceError">{{ performanceError }}</p>

    <div class="row">
      <!-- Total Contests Card -->
      <div class="col-lg-3 col-md-6">
        <div class="contest-ov-card">
          <div class="icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="16" fill="#DBEAFF" />
              <path
                d="M16 19C16.8741 19 17.6171 18.7083 18.229 18.125C18.8409 17.5417 19.1469 16.8333 19.1469 16C19.1469 15.1667 18.8409 14.4583 18.229 13.875C17.6171 13.2917 16.8741 13 16 13C15.1259 13 14.3829 13.2917 13.771 13.875C13.1591 14.4583 12.8531 15.1667 12.8531 16C12.8531 16.8333 13.1591 17.5417 13.771 18.125C14.3829 18.7083 15.1259 19 16 19ZM16 17.8C15.4755 17.8 15.0297 17.625 14.6626 17.275C14.2955 16.925 14.1119 16.5 14.1119 16C14.1119 15.5 14.2955 15.075 14.6626 14.725C15.0297 14.375 15.4755 14.2 16 14.2C16.5245 14.2 16.9703 14.375 17.3374 14.725C17.7045 15.075 17.8881 15.5 17.8881 16C17.8881 16.5 17.7045 16.925 17.3374 17.275C16.9703 17.625 16.5245 17.8 16 17.8ZM16 21C14.4382 21 13.0134 20.6 11.7255 19.8C10.4376 19 9.42075 17.9444 8.67483 16.6333C8.61655 16.5333 8.57284 16.4306 8.54371 16.325C8.51457 16.2194 8.5 16.1111 8.5 16C8.5 15.8889 8.51457 15.7806 8.54371 15.675C8.57284 15.5694 8.61655 15.4667 8.67483 15.3667C9.42075 14.0556 10.4376 13 11.7255 12.2C13.0134 11.4 14.4382 11 16 11C17.5618 11 18.9866 11.4 20.2745 12.2C21.5624 13 22.5793 14.0556 23.3252 15.3667C23.3834 15.4667 23.4272 15.5694 23.4563 15.675C23.4854 15.7806 23.5 15.8889 23.5 16C23.5 16.1111 23.4854 16.2194 23.4563 16.325C23.4272 16.4306 23.3834 16.5333 23.3252 16.6333C22.5793 17.9444 21.5624 19 20.2745 19.8C18.9866 20.6 17.5618 21 16 21Z"
                fill="#1C69FF" />
            </svg>
          </div>
          <div class="content">
            <h6>{{ 'contestDetails.totalViews' | translate }} <span nz-tooltip [nzTooltipTitle]="'contestDetails.tooltips.totalViews' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center;"><i class="fa-solid fa-circle-info ms-1" style="font-size: 12px; color: #9CA3AF;"></i></span></h6>
            <span
              [class]="getTrendBadge(performanceTrends.totalContests).isPositive ? 'badge bg-success' : 'badge bg-danger'">
              <img
                [src]="getTrendBadge(performanceTrends.totalContests).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                alt="">
              {{ getTrendBadge(performanceTrends.totalContests).value | number:'1.0-0' }}%
              {{ getTrendBadge(performanceTrends.totalContests).isPositive ? ('contestDetails.higher' | translate) : ('contestDetails.lower' | translate) }}
            </span>
          </div>
          <div class="value">
            <h4>{{ performanceStats.totalContests | number }}</h4>
          </div>
        </div>
      </div>

      <!-- Active Contests Card -->
      <div class="col-lg-3 col-md-6">
        <div class="contest-ov-card">
          <div class="icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="16" fill="#D1FAE5" />
              <path
                d="M16 21.6C16.875 21.6 17.6187 21.2937 18.2312 20.6812C18.8438 20.0687 19.15 19.325 19.15 18.45C19.15 17.575 18.8438 16.8312 18.2312 16.2188C17.6187 15.6062 16.875 15.3 16 15.3C15.125 15.3 14.3812 15.6062 13.7687 16.2188C13.1562 16.8312 12.85 17.575 12.85 18.45C12.85 19.325 13.1562 20.0687 13.7687 20.6812C14.3812 21.2937 15.125 21.6 16 21.6ZM13.9525 14.39C14.1858 14.2617 14.4337 14.1596 14.6962 14.0838C14.9587 14.0079 15.2242 13.9583 15.4925 13.935L13.725 10.4H11.975L13.9525 14.39ZM12.08 20.76C11.8817 20.4217 11.7271 20.0571 11.6163 19.6663C11.5054 19.2754 11.45 18.87 11.45 18.45C11.45 18.03 11.5054 17.6246 11.6163 17.2337C11.7271 16.8429 11.8817 16.4783 12.08 16.14C11.59 16.3033 11.1875 16.5921 10.8725 17.0062C10.5575 17.4204 10.4 17.9017 10.4 18.45C10.4 18.9983 10.5575 19.4796 10.8725 19.8938C11.1875 20.3079 11.59 20.5967 12.08 20.76ZM19.92 20.76C20.41 20.5967 20.8125 20.3079 21.1275 19.8938C21.4425 19.4796 21.6 18.9983 21.6 18.45C21.6 17.9017 21.4425 17.4204 21.1275 17.0062C20.8125 16.5921 20.41 16.3033 19.92 16.14C20.1183 16.4783 20.2729 16.8429 20.3837 17.2337C20.4946 17.6246 20.55 18.03 20.55 18.45C20.55 18.87 20.4946 19.2754 20.3837 19.6663C20.2729 20.0571 20.1183 20.4217 19.92 20.76ZM16 23C15.5333 23 15.0871 22.9329 14.6613 22.7987C14.2354 22.6646 13.8417 22.4808 13.48 22.2475C13.375 22.2708 13.27 22.2854 13.165 22.2913C13.06 22.2971 12.9492 22.3 12.8325 22.3C11.7708 22.3 10.8667 21.9267 10.12 21.18C9.37333 20.4333 9 19.5292 9 18.4675C9 17.4525 9.33833 16.5833 10.015 15.86C10.6917 15.1367 11.5258 14.7342 12.5175 14.6525L10.2075 10.015C10.0908 9.78167 10.0996 9.55417 10.2337 9.3325C10.3679 9.11083 10.5692 9 10.8375 9H13.7425C14.0108 9 14.2529 9.07 14.4688 9.21C14.6846 9.35 14.8567 9.53667 14.985 9.77L16 11.8L17.015 9.77C17.1433 9.53667 17.3154 9.35 17.5312 9.21C17.7471 9.07 17.9892 9 18.2575 9H21.1625C21.4308 9 21.6321 9.11083 21.7663 9.3325C21.9004 9.55417 21.9092 9.78167 21.7925 10.015L19.5 14.6175C20.4917 14.7108 21.3229 15.1192 21.9937 15.8425C22.6646 16.5658 23 17.435 23 18.45C23 19.5233 22.6267 20.4333 21.88 21.18C21.1333 21.9267 20.2233 22.3 21.95 22.3C19.045 22.3 18.9371 22.2971 18.8263 22.2913C18.7154 22.2854 18.6075 22.2708 18.5025 22.2475C18.1408 22.4808 17.75 22.6646 17.33 22.7987C16.91 22.9329 16.4667 23 16 23ZM16 19.395L15.1425 20.0425C15.0725 20.1008 15.0025 20.1038 14.9325 20.0513C14.8625 19.9987 14.8392 19.9317 14.8625 19.85L15.195 18.7825L14.3375 18.17C14.2675 18.1117 14.2442 18.0446 14.2675 17.9688C14.2908 17.8929 14.3492 17.855 14.4425 17.855H15.4925L15.825 16.7175C15.8483 16.6358 15.9067 16.595 16 16.595C16.0933 16.595 16.1517 16.6358 16.175 16.7175L16.5075 17.855H17.5575C17.6508 17.855 17.7092 17.8929 17.7325 17.9688C17.7558 18.0446 17.7325 18.1117 17.6625 18.17L16.805 18.7825L17.1375 19.85C17.1608 19.9317 17.1375 19.9987 17.0675 20.0513C16.9975 20.1038 16.9275 20.1008 16.8575 20.0425L16 19.395ZM18.0475 14.39L20.0425 10.4H18.275L16.7875 13.375L17.12 14.04C17.2833 14.0867 17.4408 14.1363 17.5925 14.1887C17.7442 14.2413 17.8958 14.3083 18.0475 14.39Z"
                fill="#00AC4F" />
            </svg>
          </div>
          <div class="content">
            <h6>{{ 'contestDetails.totalClicks' | translate }} <span nz-tooltip [nzTooltipTitle]="'contestDetails.tooltips.totalClicks' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center;"><i class="fa-solid fa-circle-info ms-1" style="font-size: 12px; color: #9CA3AF;"></i></span></h6>
            <span
              [class]="getTrendBadge(performanceTrends.activeContests).isPositive ? 'badge bg-success' : 'badge bg-danger'">
              <img
                [src]="getTrendBadge(performanceTrends.activeContests).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                alt="">
              {{ getTrendBadge(performanceTrends.activeContests).value | number:'1.0-0' }}%
              {{ getTrendBadge(performanceTrends.activeContests).isPositive ? ('contestDetails.higher' | translate) : ('contestDetails.lower' | translate) }}
            </span>
          </div>
          <div class="value">
            <h4>{{ performanceStats.activeContests | number }}</h4>
          </div>
        </div>
      </div>

      <!-- Pending Contests Card -->
      <div class="col-lg-3 col-md-6">
        <div class="contest-ov-card">
          <div class="icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="16" fill="#6826FC" fill-opacity="0.1" />
              <path
                d="M22.0173 23.5789L19.3816 20.9624L18.7825 22.78C18.716 22.9664 18.5895 23.0563 18.4031 23.0496C18.2168 23.043 18.0903 22.9464 18.0238 22.76L16.2067 16.7082C16.1535 16.5617 16.1867 16.4286 16.3065 16.3087C16.4263 16.1889 16.5595 16.1556 16.7059 16.2089L22.7561 18.0264C22.9425 18.093 23.039 18.2195 23.0456 18.4059C23.0523 18.5923 22.9624 18.7188 22.7761 18.7854L20.959 19.3846L23.5947 22.021C23.821 22.2474 23.9342 22.507 23.9342 22.8C23.9342 23.0929 23.821 23.3525 23.5947 23.5789C23.3684 23.8053 23.1055 23.9184 22.806 23.9184C22.5065 23.9184 22.2436 23.8053 22.0173 23.5789ZM15.9871 9.59784C14.2033 9.59784 12.6924 10.217 11.4544 11.4553C10.2164 12.6936 9.59741 14.2049 9.59741 15.9892C9.59741 17.6669 10.1499 19.105 11.2547 20.3033C12.3596 21.5017 13.744 22.1808 15.408 22.3406C15.6343 22.3672 15.8306 22.4671 15.997 22.6402C16.1634 22.8133 16.24 23.013 16.2267 23.2394C16.2134 23.4657 16.1302 23.6521 15.9771 23.7986C15.824 23.9451 15.6343 24.0117 15.408 23.9983C14.3697 23.9318 13.4012 23.6721 12.5027 23.2194C11.6042 22.7667 10.8188 22.1775 10.1465 21.4518C9.47428 20.7261 8.94846 19.8939 8.56908 18.9552C8.18969 18.0164 8 17.0278 8 15.9892C8 14.884 8.20966 13.8454 8.62898 12.8734C9.0483 11.9014 9.61738 11.0559 10.3362 10.3368C11.055 9.61781 11.9003 9.04858 12.8721 8.62915C13.8439 8.20972 14.8822 8 15.9871 8C18.077 8 19.8974 8.71237 21.4482 10.1371C22.999 11.5618 23.8477 13.3195 23.9941 15.41C24.0207 15.623 23.9575 15.8061 23.8044 15.9592C23.6513 16.1123 23.4616 16.1956 23.2353 16.2089C23.009 16.2222 22.806 16.149 22.6263 15.9892C22.4466 15.8294 22.3434 15.6363 22.3168 15.41C22.1171 13.8121 21.4216 12.444 20.2302 11.3055C19.0388 10.1671 17.6244 9.59784 15.9871 9.59784Z"
                fill="url(#paint0_linear_40000187_8546)" />
              <defs>
                <linearGradient id="paint0_linear_40000187_8546" x1="2.7775" y1="37.4542" x2="27.7699"
                  y2="24.6235" gradientUnits="userSpaceOnUse">
                  <stop offset="0.14" stop-color="#8F67FD" />
                  <stop offset="1" stop-color="#5304FB" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="content">
            <h6>{{ 'contestDetails.participants' | translate }} <span nz-tooltip [nzTooltipTitle]="'contestDetails.tooltips.participants' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center;"><i class="fa-solid fa-circle-info ms-1" style="font-size: 12px; color: #9CA3AF;"></i></span></h6>
            <span
              [class]="getTrendBadge(performanceTrends.pendingContests).isPositive ? 'badge bg-success' : 'badge bg-danger'">
              <img
                [src]="getTrendBadge(performanceTrends.pendingContests).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                alt="">
              {{ getTrendBadge(performanceTrends.pendingContests).value | number:'1.0-0' }}%
              {{ getTrendBadge(performanceTrends.pendingContests).isPositive ? ('contestDetails.higher' | translate) : ('contestDetails.lower' | translate) }}
            </span>
          </div>
          <div class="value">
            <h4>{{ performanceStats.pendingContests | number }}</h4>
          </div>
        </div>
      </div>

      <!-- Finished Contests Card -->
      <div class="col-lg-3 col-md-6">
        <div class="contest-ov-card">
          <div class="icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="16" fill="#FFEDD4" />
              <path
                d="M16.375 15.9625C16.7375 15.5625 17.0156 15.1062 17.2094 14.5938C17.4031 14.0813 17.5 13.55 17.5 13C17.5 12.45 17.4031 11.9188 17.2094 11.4062C17.0156 10.8938 16.7375 10.4375 16.375 10.0375C17.125 10.1375 17.75 10.4688 18.25 11.0312C18.75 11.5938 19 12.25 19 13C19 13.75 18.75 14.4062 18.25 14.9688C17.75 15.5312 17.125 15.8625 16.375 15.9625ZM20.0875 22C20.225 21.775 20.3281 21.5344 20.3969 21.2781C20.4656 21.0219 20.5 20.7625 20.5 20.5V19.75C20.5 19.3 20.4 18.8719 20.2 18.4656C20 18.0594 19.7375 17.7 19.4125 17.3875C20.05 17.6125 20.6406 17.9031 21.1844 18.2594C21.7281 18.6156 22 19.1125 22 19.75V20.5C22 20.9125 21.8531 21.2656 21.5594 21.5594C21.2656 21.8531 20.9125 22 20.5 22H20.0875ZM22 15.25H21.25C21.0375 15.25 20.8594 15.1781 20.7156 15.0344C20.5719 14.8906 20.5 14.7125 20.5 14.5C20.5 14.2875 20.5719 14.1094 20.7156 13.9656C20.8594 13.8219 21.0375 13.75 21.25 13.75H22V13C22 12.7875 22.0719 12.6094 22.2156 12.4656C22.3594 12.3219 22.5375 12.25 22.75 12.25C22.9625 12.25 23.1406 12.3219 23.2844 12.4656C23.4281 12.6094 23.5 12.7875 23.5 13V13.75H24.25C24.4625 13.75 24.6406 13.8219 24.7844 13.9656C24.9281 14.1094 25 14.2875 25 14.5C25 14.7125 24.9281 14.8906 24.7844 15.0344C24.6406 15.1781 24.4625 15.25 24.25 15.25H23.5V16C23.5 16.2125 23.4281 16.3906 23.2844 16.5344C23.1406 16.6781 22.9625 16.75 22.75 16.75C22.5375 16.75 22.3594 16.6781 22.2156 16.5344C22.0719 16.3906 22 16.2125 22 16V15.25ZM13 16C12.175 16 11.4688 15.7063 10.8813 15.1188C10.2938 14.5312 10 13.825 10 13C10 12.175 10.2938 11.4688 10.8813 10.8813C11.4688 10.2938 12.175 10 13 10C13.825 10 14.5312 10.2938 15.1187 10.8813C15.7063 11.4688 16 12.175 16 13C16 13.825 15.7063 14.5312 15.1187 15.1188C14.5312 15.7063 13.825 16 13 16ZM7 20.5V19.9C7 19.475 7.10937 19.0844 7.32812 18.7281C7.54688 18.3719 7.8375 18.1 8.2 17.9125C8.975 17.525 9.7625 17.2344 10.5625 17.0406C11.3625 16.8469 12.175 16.75 13 16.75C13.825 16.75 14.6375 16.8469 15.4375 17.0406C16.2375 17.2344 17.025 17.525 17.8 17.9125C18.1625 18.1 18.4531 18.3719 18.6719 18.7281C18.8906 19.0844 19 19.475 19 19.9V20.5C19 20.9125 18.8531 21.2656 18.5594 21.5594C18.2656 21.8531 17.9125 22 17.5 22H8.5C8.0875 22 7.73438 21.8531 7.44063 21.5594C7.14688 21.2656 7 20.9125 7 20.5ZM13 14.5C13.4125 14.5 13.7656 14.3531 14.0594 14.0594C14.3531 13.7656 14.5 13.4125 14.5 13C14.5 12.5875 14.3531 12.2344 14.0594 11.9406C13.7656 11.6469 13.4125 11.5 13 11.5C12.5875 11.5 12.2344 11.6469 11.9406 11.9406C11.6469 12.2344 11.5 12.5875 11.5 13C11.5 13.4125 11.6469 13.7656 11.9406 14.0594C12.2344 14.3531 12.5875 14.5 13 14.5ZM8.5 20.5H17.5V19.9C17.5 19.7625 17.4656 19.6375 17.3969 19.525C17.3281 19.4125 17.2375 19.325 17.125 19.2625C16.45 18.925 15.7688 18.6719 15.0813 18.5031C14.3938 18.3344 13.7 18.25 13 18.25C12.3 18.25 11.6062 18.3344 10.9187 18.5031C10.2312 18.6719 9.55 18.925 8.875 19.2625C8.7625 19.325 8.67188 19.4125 8.60313 19.525C8.53438 19.6375 8.5 19.7625 8.5 19.9V20.5Z"
                fill="url(#paint0_linear_40000187_8559)" />
              <defs>
                <linearGradient id="paint0_linear_40000187_8559" x1="9.19231" y1="14.5882" x2="28.1746"
                  y2="27.294" gradientUnits="userSpaceOnUse">
                  <stop offset="0.101119" stop-color="#FB513F" />
                  <stop offset="1" stop-color="#FC8B2E" stop-opacity="0.46" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="content">
            <h6>{{ 'contestDetails.completed' | translate }} <span nz-tooltip [nzTooltipTitle]="'contestDetails.tooltips.completed' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center;"><i class="fa-solid fa-circle-info ms-1" style="font-size: 12px; color: #9CA3AF;"></i></span></h6>
            <span
              [class]="getTrendBadge(performanceTrends.finishedContests).isPositive ? 'badge bg-success' : 'badge bg-danger'">
              <img
                [src]="getTrendBadge(performanceTrends.finishedContests).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                alt="">
              {{ getTrendBadge(performanceTrends.finishedContests).value | number:'1.0-0' }}%
              {{ getTrendBadge(performanceTrends.finishedContests).isPositive ? ('contestDetails.higher' | translate) : ('contestDetails.lower' | translate) }}
            </span>
          </div>
          <div class="value">
            <h4>{{ performanceStats.finishedContests | number }}</h4>
          </div>
        </div>
      </div>

      <!-- Overall Success Rate Card -->
      <div class="col-lg-3 col-md-6">
        <div class="contest-ov-card">
          <div class="content">
            <h6>{{ 'contestDetails.overallSuccessRate' | translate }} <span nz-tooltip [nzTooltipTitle]="'contestDetails.tooltips.overallSuccessRate' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center;"><i class="fa-solid fa-circle-info ms-1" style="font-size: 12px; color: #9CA3AF;"></i></span></h6>
            <span
              [class]="getTrendBadge(performanceTrends.overallSuccessRate).isPositive ? 'badge bg-success' : 'badge bg-danger'">
              <img
                [src]="getTrendBadge(performanceTrends.overallSuccessRate).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                alt="">
              {{ getTrendBadge(performanceTrends.overallSuccessRate).value | number:'1.0-0' }}%
              {{ getTrendBadge(performanceTrends.overallSuccessRate).isPositive ? ('contestDetails.higher' | translate) : ('contestDetails.lower' | translate) }}
            </span>
          </div>
          <div class="value">
            <h4>{{ performanceStats.avgClickRate | number:'1.0-2' }}%</h4>
          </div>
          <div>
            <div class="progress">
              <div class="progress-fill" [style.width.%]="performanceStats.avgClickRate"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Average Completion Rate Card -->
      <div class="col-lg-3 col-md-6">
        <div class="contest-ov-card">
          <div class="content">
            <h6>{{ 'contestDetails.completionRate' | translate }} <span nz-tooltip [nzTooltipTitle]="'contestDetails.tooltips.completionRate' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center;"><i class="fa-solid fa-circle-info ms-1" style="font-size: 12px; color: #9CA3AF;"></i></span></h6>
            <span
              [class]="getTrendBadge(performanceTrends.avgCompletionRate).isPositive ? 'badge bg-success' : 'badge bg-danger'">
              <img
                [src]="getTrendBadge(performanceTrends.avgCompletionRate).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                alt="">
              {{ getTrendBadge(performanceTrends.avgCompletionRate).value | number:'1.0-0' }}%
              {{ getPercentageChange(performanceStats.avgCompletionRate,
              performancePreviousStats.avgCompletionRate).isPositive ? ('contestDetails.higher' | translate) : ('contestDetails.lower' | translate) }}
            </span>
          </div>
          <div class="value">
            <h4>{{ performanceStats.avgCompletionRate | number:'1.0-2' }}%</h4>
          </div>
          <div>
            <div class="progress">
              <div class="progress-fill" [style.width.%]="performanceStats.avgCompletionRate"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Average Participation Rate Card -->
      <div class="col-lg-3 col-md-6">
        <div class="contest-ov-card">
          <div class="content">
            <h6>{{ 'contestDetails.participationRate' | translate }} <span nz-tooltip [nzTooltipTitle]="'contestDetails.tooltips.participationRate' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center;"><i class="fa-solid fa-circle-info ms-1" style="font-size: 12px; color: #9CA3AF;"></i></span></h6>
            <span
              [class]="getTrendBadge(performanceTrends.avgParticipationRate).isPositive ? 'badge bg-success' : 'badge bg-danger'">
              <img
                [src]="getTrendBadge(performanceTrends.avgParticipationRate).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                alt="">
              {{ getPercentageChange(performanceStats.avgParticipationRate,
              performancePreviousStats.avgParticipationRate).value | number:'1.0-0' }}%
              {{ getPercentageChange(performanceStats.avgParticipationRate,
              performancePreviousStats.avgParticipationRate).isPositive ? ('contestDetails.higher' | translate) : ('contestDetails.lower' | translate) }}
            </span>
          </div>
          <div class="value">
            <h4>{{ performanceStats.avgParticipationRate | number:'1.0-2' }}%</h4>
          </div>
          <div>
            <div class="progress">
              <div class="progress-fill" [style.width.%]="performanceStats.avgParticipationRate"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Average Engagement Rate Card -->
      <div class="col-lg-3 col-md-6">
        <div class="contest-ov-card">
          <div class="content">
            <h6>{{ 'contestDetails.engagementRate' | translate }} <span nz-tooltip [nzTooltipTitle]="'contestDetails.tooltips.engagementRate' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center;"><i class="fa-solid fa-circle-info ms-1" style="font-size: 12px; color: #9CA3AF;"></i></span></h6>
            <span
              [class]="getTrendBadge(performanceTrends.avgEngagementRate).isPositive ? 'badge bg-success' : 'badge bg-danger'">
              <img
                [src]="getTrendBadge(performanceTrends.avgEngagementRate).isPositive ? '../../../../assets/images/trending_up.svg' : '../../../../assets/images/trending_down.svg'"
                alt="">
              {{ getTrendBadge(performanceTrends.avgEngagementRate).value | number:'1.0-0' }}%
              {{ getPercentageChange(performanceStats.avgEngagementRate,
              performancePreviousStats.avgEngagementRate).isPositive ? ('contestDetails.higher' | translate) : ('contestDetails.lower' | translate) }}
            </span>
          </div>
          <div class="value">
            <h4>{{ performanceStats.avgEngagementRate | number:'1.0-2' }}%</h4>
          </div>
          <div>
            <div class="progress">
              <div class="progress-fill" [style.width.%]="performanceStats.avgEngagementRate"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Level Matrix -->
  <div class="luqta-card">
    <div class="card-heading" style="display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:10px;">
      <h3>{{ 'contestDetails.levelMatrix' | translate }}</h3>
      <span style="font-size:12px; color:#888; font-style:italic;">
        {{ (isArabic && levelMatrix?.arabic_name) ? levelMatrix.arabic_name : (levelMatrix?.contest_name || '') }}
        — {{ levelMatrix?.total_participants ?? 0 }} {{ 'contestDetails.participantsSuffix' | translate }}
      </span>
    </div>

    <p *ngIf="levelMetricsLoading" class="text-muted">{{ 'contestDetails.loadingLevelMatrix' | translate }}</p>
    <p *ngIf="levelMetricsError && !levelMetricsLoading" class="text-danger">{{ levelMetricsError }}</p>

    <nz-table *ngIf="!levelMetricsLoading && !levelMetricsError && levelMatrix?.levels?.length"
      #levelMatrixTable [nzData]="levelMatrix.levels" [nzBordered]="true"
      [nzScroll]="{ x: '960px' }" [nzPageSize]="10" [nzShowPagination]="levelMatrix.levels.length > 10">
      <thead>
        <tr>
          <th nzWidth="220px">{{ 'contestDetails.levels.level' | translate }}</th>
          <th nzWidth="130px">{{ 'contestDetails.type' | translate }}</th>
          <th nzWidth="110px">{{ 'contestDetails.completed' | translate }}</th>
          <th nzWidth="110px">{{ 'contestDetails.inProgress' | translate }}</th>
          <th nzWidth="110px">{{ 'contestDetails.notStarted' | translate }}</th>
          <th nzWidth="140px">{{ 'contestDetails.completionRate' | translate }}</th>
          <th nzWidth="90px" nzRight>{{ 'contestDetails.view' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let level of levelMatrixTable.data">
          <td>{{ (isArabic && level.arabic_name) ? level.arabic_name : (level.level_name || 'N/A') }}</td>
          <td>{{ getLevelTypeLabel(level) }}</td>
          <td>{{ level.completed_count ?? 0 }}</td>
          <td>{{ level.in_progress_count ?? 0 }}</td>
          <td>{{ level.not_started_count ?? 0 }}</td>
          <td>
            <div class="content-center">
              <div class="progress-cell">
                <div class="progress">
                  <div class="progress-fill"
                    [style.width.%]="(level.completion_rate ?? 0) > 100 ? 100 : (level.completion_rate ?? 0)">
                  </div>
                </div>
                <span class="progress-text">{{ (level.completion_rate ?? 0) | number:'1.0-1' }}%</span>
              </div>
            </div>
          </td>
          <td nzRight>
            <svg (click)="openLevelDemographicsDrawer(level)" width="18" height="18" viewBox="0 0 18 18"
              fill="none" xmlns="http://www.w3.org/2000/svg" nz-tooltip [nzTooltipTitle]="'contestDetails.viewDemographicBreakdown' | translate"
              style="cursor: pointer;">
              <mask id="mask0_level_matrix_view" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"
                style="mask-type: alpha;">
                <rect width="17.7778" height="17.7778" fill="#D9D9D9"></rect>
              </mask>
              <g mask="url(#mask0_level_matrix_view)">
                <path
                  d="M8.89034 11.8518C9.81626 11.8518 10.6033 11.5277 11.2514 10.8796C11.8996 10.2314 12.2237 9.44437 12.2237 8.51845C12.2237 7.59252 11.8996 6.80548 11.2514 6.15734C10.6033 5.50919 9.81626 5.18511 8.89034 5.18511C7.96441 5.18511 7.17737 5.50919 6.52922 6.15734C5.88108 6.80548 5.557 7.59252 5.557 8.51845C5.557 9.44437 5.88108 10.2314 6.52922 10.8796C7.17737 11.5277 7.96441 11.8518 8.89034 11.8518ZM8.89034 10.5184C8.33478 10.5184 7.86256 10.324 7.47367 9.93511C7.08478 9.54622 6.89034 9.074 6.89034 8.51845C6.89034 7.96289 7.08478 7.49067 7.47367 7.10178C7.86256 6.71289 8.33478 6.51845 8.89034 6.51845C9.44589 6.51845 9.91811 6.71289 10.307 7.10178C10.6959 7.49067 10.8903 7.96289 10.8903 8.51845C10.8903 9.074 10.6959 9.54622 10.307 9.93511C9.91811 10.324 9.44589 10.5184 8.89034 10.5184ZM8.89034 14.074C7.08787 14.074 5.44589 13.5709 3.96441 12.5647C2.48293 11.5586 1.40885 10.2098 0.742188 8.51845C1.40885 6.82709 2.48293 5.47832 3.96441 4.47215C5.44589 3.46598 7.08787 2.96289 8.89034 2.96289C10.6928 2.96289 12.3348 3.46598 13.8163 4.47215C15.2977 5.47832 16.3718 6.82709 17.0385 8.51845C16.3718 10.2098 15.2977 11.5586 13.8163 12.5647C12.3348 13.5709 10.6928 14.074 8.89034 14.074ZM8.89034 12.5925C10.2854 12.5925 11.5663 12.2252 12.7329 11.4907C13.8996 10.7561 14.7916 9.76536 15.4089 8.51845C14.7916 7.27153 13.8996 6.28079 12.7329 5.54622C11.5663 4.81166 10.2854 4.44437 8.89034 4.44437C7.49527 4.44437 6.21441 4.81166 5.04774 5.54622C3.88108 6.28079 2.9891 7.27153 2.37182 8.51845C2.9891 9.76536 3.88108 10.7561 5.04774 11.4907C6.21441 12.2252 7.49527 12.5925 8.89034 12.5925Z"
                  fill="#1C1B1F"></path>
              </g>
            </svg>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <p *ngIf="!levelMetricsLoading && !levelMetricsError && !levelMatrix?.levels?.length" class="text-muted">{{ 'contestDetails.noLevelData' | translate }}</p>
  </div>

  <!-- Leaderboard Section — only for top_points contests -->
  <div class="luqta-card" *ngIf="contests_detail?.draw_type === 'top_points'">
    <div class="card-heading" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
      <h3>{{ 'contestDetails.pointsLeaderboard' | translate }}</h3>
      <span style="font-size: 12px; color: #888; font-style: italic;">{{ 'contestDetails.rankedByPoints' | translate }}</span>
    </div>
    <p *ngIf="leaderboardLoading" class="text-muted">{{ 'contestDetails.loadingLeaderboard' | translate }}</p>
    <nz-table *ngIf="!leaderboardLoading" [nzData]="leaderboard" [nzBordered]="true"
      [nzFrontPagination]="false" [nzTotal]="leaderboardTotal"
      [nzPageIndex]="leaderboardPage" [nzPageSize]="leaderboardPerPage"
      [nzShowPagination]="leaderboardTotal > leaderboardPerPage"
      (nzPageIndexChange)="buildLeaderboard($event)">
      <thead>
        <tr>
          <th nzWidth="70px">{{ 'contestDetails.rank' | translate }}</th>
          <th nzWidth="200px">{{ 'contestDetails.participant' | translate }}</th>
          <th nzWidth="120px">{{ 'contestDetails.points' | translate }}</th>
          <th nzWidth="150px">{{ 'common.status' | translate }}</th>
          <th nzWidth="110px">{{ 'contestDetails.gender' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of leaderboard">
          <td><span style="font-weight: 600; color: #555;">{{ row._rank }}</span></td>
          <td>{{ row._name }}</td>
          <td><b style="color: #7C3AED;">{{ row._points | number }}</b></td>
          <td>
            <span class="badge rounded-pill"
              [ngClass]="row.status === 'completed' ? 'bg-success' : (row.status === 'not_started' ? 'bg-secondary' : 'bg-warning')">
              {{ row.status === 'completed' ? ('contestDetails.completed' | translate) : (row.status === 'not_started' ? ('contestDetails.notStarted' | translate) : ('contestDetails.inProgress' | translate)) }}
            </span>
          </td>
          <td>{{ row._gender || 'N/A' }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <!-- QR Instances — Web QR campaigns only -->
  <div class="luqta-card qr-instances-card" *ngIf="isWebQrCampaign">
    <div class="card-heading qr-instances-heading">
      <div>
        <h3>{{ 'contestDetails.qrInstances' | translate }}
          <span *ngIf="qrInstances.length">({{ qrInstances.length }})</span>
        </h3>
        <p class="card-subtitle">{{ 'contestDetails.qrInstancesSubtitle' | translate }}</p>
      </div>
      <button type="button" class="btn btn-light manage-qr-btn" (click)="manageQrInstances()">
        <i class="fa-solid fa-qrcode" aria-hidden="true"></i>
        <span>{{ 'contestDetails.manageQrInstances' | translate }}</span>
      </button>
    </div>

    <nz-table #qrInstancesTable [nzData]="qrInstances" [nzBordered]="true" [nzLoading]="qrInstancesLoading"
      [nzScroll]="{ x: '1180px' }" [nzPageSize]="5" [nzShowPagination]="qrInstances.length > 5"
      [nzNoResult]="qrInstancesEmpty">
      <thead>
        <tr>
          <th nzWidth="50px">#</th>
          <th nzWidth="180px">{{ 'webQr.form.label.label' | translate }}</th>
          <th nzWidth="120px">{{ 'webQr.form.placementType.label' | translate }}</th>
          <th nzWidth="110px">{{ 'webQr.status.label' | translate }}</th>
          <th nzWidth="90px">{{ 'webQr.scans' | translate }}</th>
          <th nzWidth="290px">{{ 'webQr.shortLink' | translate }}</th>
          <th nzWidth="170px">{{ 'webQr.form.expiresAt.label' | translate }}</th>
          <th nzWidth="170px">{{ 'webQr.createdAt' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let instance of qrInstancesTable.data; let i = index">
          <td>{{ (qrInstancesTable.nzPageIndex - 1) * qrInstancesTable.nzPageSize + i + 1 }}</td>
          <td>{{ instance.label || '-' }}</td>
          <td>
            <span class="qr-placement-badge" [class.digital]="instance.placement_type === 'digital'">
              {{ getQrPlacementLabel(instance.placement_type) }}
            </span>
          </td>
          <td>
            <span class="qr-status-badge" [ngClass]="getQrInstanceStatusKey(instance)">
              {{ 'webQr.status.' + getQrInstanceStatusKey(instance) | translate }}
            </span>
          </td>
          <td>{{ instance.scan_count ?? 0 }}</td>
          <td>
            <div class="qr-link-cell" *ngIf="instance.short_link; else noQrLink">
              <span class="qr-link-text" dir="ltr" [title]="instance.short_link">{{ instance.short_link }}</span>
              <button type="button" class="row-icon-btn" (click)="copyQrInstanceLink(instance.short_link)"
                nz-tooltip [nzTooltipTitle]="'webQr.copyLink' | translate" [attr.aria-label]="'webQr.copyLink' | translate">
                <i class="fa-regular fa-copy" aria-hidden="true"></i>
              </button>
              <a class="row-icon-btn" [href]="instance.short_link" target="_blank" rel="noopener noreferrer"
                nz-tooltip [nzTooltipTitle]="'contestDetails.openQrLink' | translate"
                [attr.aria-label]="'contestDetails.openQrLink' | translate">
                <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
              </a>
            </div>
            <ng-template #noQrLink>-</ng-template>
          </td>
          <td>
            <span *ngIf="instance.expires_at; else noQrExpiry"
              [class.text-danger]="getQrInstanceStatusKey(instance) === 'expired'">
              {{ instance.expires_at | date: 'dd/MM/yy hh:mm a' }}
            </span>
            <ng-template #noQrExpiry><span class="text-muted">{{ 'webQr.noExpiry' | translate }}</span></ng-template>
          </td>
          <td>{{ instance.created_at ? (instance.created_at | date: 'dd/MM/yy hh:mm a') : '-' }}</td>
        </tr>
      </tbody>
    </nz-table>

    <ng-template #qrInstancesEmpty>
      <div class="qr-instances-empty">
        <i class="fa-solid fa-qrcode" aria-hidden="true"></i>
        <p>{{ 'webQr.emptyTitle' | translate }}</p>
      </div>
    </ng-template>
  </div>

  <!-- Participants Section - Always show table -->
  <div class="luqta-card">
    <div class="card-heading"
      style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
      <h3>{{ 'contestDetails.participantsCount' | translate: { count: filteredParticipants.length } }}
        <span nz-tooltip [nzTooltipTitle]="'contestDetails.participantsHeadingTooltip' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center; margin-inline-start: 4px;">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_part" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
              <rect width="14" height="14" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_part)">
              <path
                d="M6.41797 9.91602H7.58464V6.41602H6.41797V9.91602ZM7.0013 5.24935C7.16658 5.24935 7.30512 5.19345 7.41693 5.08164C7.52873 4.96984 7.58464 4.83129 7.58464 4.66602C7.58464 4.50074 7.52873 4.3622 7.41693 4.25039C7.30512 4.13859 7.16658 4.08268 7.0013 4.08268C6.83602 4.08268 6.69748 4.13859 6.58568 4.25039C6.47387 4.3622 6.41797 4.50074 6.41797 4.66602C6.41797 4.83129 6.47387 4.96984 6.58568 5.08164C6.69748 5.19345 6.83602 5.24935 7.0013 5.24935ZM7.0013 12.8327C6.19436 12.8327 5.43602 12.6796 4.7263 12.3733C4.01658 12.0671 3.39922 11.6514 2.87422 11.1264C2.34922 10.6014 1.93359 9.98407 1.62734 9.27435C1.32109 8.56463 1.16797 7.80629 1.16797 6.99935C1.16797 6.1924 1.32109 5.43407 1.62734 4.72435C1.93359 4.01463 2.34922 3.39727 2.87422 2.87227C3.39922 2.34727 4.01658 1.93164 4.7263 1.62539C5.43602 1.31914 6.19436 1.16602 7.0013 1.16602C7.80825 1.16602 8.56658 1.31914 9.2763 1.62539C9.98602 1.93164 10.6034 2.34727 11.1284 2.87227C11.6534 3.39727 12.069 4.01463 12.3753 4.72435C12.6815 5.43407 12.8346 6.1924 12.8346 6.99935C12.8346 7.80629 12.6815 8.56463 12.3753 9.27435C12.069 9.98407 11.6534 10.6014 11.1284 11.1264C10.6034 11.6514 9.98602 12.0671 9.2763 12.3733C8.56658 12.6796 7.80825 12.8327 7.0013 12.8327ZM7.0013 11.666C8.30408 11.666 9.40755 11.2139 10.3117 10.3098C11.2159 9.4056 11.668 8.30213 11.668 6.99935C11.668 5.69657 11.2159 4.5931 10.3117 3.68893C9.40755 2.78477 8.30408 2.33268 7.0013 2.33268C5.69852 2.33268 4.59505 2.78477 3.69089 3.68893C2.78672 4.5931 2.33464 5.69657 2.33464 6.99935C2.33464 8.30213 2.78672 9.4056 3.69089 10.3098C4.59505 11.2139 5.69852 11.666 7.0013 11.666Z"
                fill="#7A7A7A" />
            </g>
          </svg>
        </span>
      </h3>
      <div style="display: flex; align-items: center; gap: 8px;">
        <div class="search" style="position: relative;">
          <input type="text" class="form-control" [placeholder]="'common.search' | translate" [(ngModel)]="searchTerm"
            (input)="onSearchChange()" autocapitalize="off"
            style="text-transform: none; height: 36px; border-radius: 8px; padding-right: 32px; font-size: 13px; min-width: 180px;">
          <i class="fa-solid fa-magnifying-glass"
            style="cursor: pointer; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: #999;"></i>
        </div>
        <button class="btn btn-light filter-btn" (click)="openFilterModal()"
          style="height: 36px; border-radius: 8px; display: flex; align-items: center; gap: 6px; font-size: 13px; border: 1px solid #e4e6eb; position: relative;">
          <i class="fa-solid fa-filter"></i>
          <span>{{ 'common.filter' | translate }}</span>
          <span *ngIf="hasActiveFilters()" (click)="clearAllFilters(); $event.stopPropagation()"
            [title]="'contestDetails.clickToClearFilters' | translate"
            style="position: absolute; top: -3px; right: -3px; width: 10px; height: 10px; background: #ff4d4f; border-radius: 50%; display: inline-block;">
          </span>
        </button>
      </div>
    </div>

    <nz-table #participantsTable [nzData]="filteredParticipants" [nzBordered]="true"
      [nzScroll]="{ x: participantsTableWidth }"
      [nzPageSize]="10" [nzShowPagination]="true">
      <thead>
        <tr>
          <th nzWidth="220px">{{ 'contestDetails.participant' | translate }}</th>
          <th nzWidth="170px">{{ 'contestDetails.phoneNumber' | translate }}</th>
          <th nzWidth="170px" *ngIf="isWebQrCampaign">{{ 'participants.qr-instance' | translate }}</th>
          <th nzWidth="170px">{{ 'contestDetails.participationDate' | translate }}</th>
          <th nzWidth="200px">{{ 'contestDetails.completionStatus' | translate }}</th>
          <th nzWidth="150px">{{ 'participants.country' | translate }}</th>
          <th nzWidth="240px" *ngFor="let level of acceptAnyTextLevels">
            <span class="text-answer-heading">
              <span class="text-answer-heading__label">{{ 'contestDetails.textAnswer' | translate }}</span>
              <span class="text-answer-heading__level" [title]="textLevelName(level)">{{ textLevelName(level) }}</span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let participant of participantsTable.data">
          <td>
            <div class="participant-info">
              <span>{{ getParticipantName(participant) }}</span>
            </div>
          </td>
          <td><span class="participant-phone" dir="ltr">{{ getParticipantPhone(participant) }}</span></td>
          <td *ngIf="isWebQrCampaign">
            <span *ngIf="getParticipantQrInstance(participant) as qrLabel; else noQrInstance" class="qr-instance-chip"
              [title]="qrLabel">
              <i class="fa-solid fa-qrcode" aria-hidden="true"></i>{{ qrLabel }}
            </span>
            <ng-template #noQrInstance><span class="text-muted">—</span></ng-template>
          </td>
          <td>{{ getParticipationDate(participant) ? (getParticipationDate(participant) | date: 'short') : 'N/A' }}</td>
          <td>
            <div class="status-with-action">
              <span class="rounded-pill-status"
                [ngStyle]="{'background-color': participant.status === 'completed' ? '#5304FB' : (participant.status === 'not_started' ? '#9CA3AF' : '#FC8B2E'), 'color': '#fff'}">
                {{ participant.status === 'completed' ? ('contestDetails.completed' | translate) : (participant.status === 'not_started' ? ('contestDetails.notStarted' | translate) : ('contestDetails.inProgress' | translate)) }}
              </span>
              <button type="button" class="row-icon-btn" (click)="openLevelsDrawer(participant)"
                nz-tooltip [nzTooltipTitle]="'contestDetails.viewLevelProgression' | translate"
                [attr.aria-label]="'contestDetails.viewLevelProgression' | translate">
                <i class="fa-regular fa-eye" aria-hidden="true"></i>
              </button>
            </div>
          </td>
          <td>
            {{ getParticipantLocation(participant) }}
          </td>
          <td *ngFor="let level of acceptAnyTextLevels">
            <ng-container *ngIf="textAnswer(participant, level) as answer">
              <span *ngIf="answer.kind === 'answer'" class="text-answer" dir="auto" [title]="answer.text">{{ answer.text }}</span>
              <span *ngIf="answer.kind === 'withheld'" class="text-answer text-answer--muted"
                nz-tooltip [nzTooltipTitle]="'contestDetails.textAnswerHiddenHint' | translate">
                <i class="fa-regular fa-eye-slash" aria-hidden="true"></i>{{ 'contestDetails.textAnswerHidden' | translate }}
              </span>
              <span *ngIf="answer.kind === 'none'" class="text-muted">—</span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <!-- Receipt submissions: each uploaded receipt, what was read from it, and approve / reject -->
  <app-contest-receipt-submissions *ngIf="receiptLevels.length" [contestId]="contestID"
    [levels]="receiptLevels"></app-contest-receipt-submissions>

  <!-- Audit records: every attempt, its answers and how it was verified (S1.3) -->
  <app-contest-audit-records [contestId]="contestID" [campaignName]="(isArabic && contests_detail?.arabic_name) || name"></app-contest-audit-records>

  <!-- Winners Section -->
  <div class="luqta-card">
    <div class="card-heading" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;">
      <h3>{{ 'contestDetails.winners' | translate }}
        <span nz-tooltip [nzTooltipTitle]="'contestDetails.winnersHeadingTooltip' | translate" nzTooltipPlacement="top" style="cursor: help; display: inline-flex; align-items: center; margin-inline-start: 4px;">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_winners" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14"
              height="14">
              <rect width="14" height="14" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_winners)">
              <path
                d="M6.41797 9.91602H7.58464V6.41602H6.41797V9.91602ZM7.0013 5.24935C7.16658 5.24935 7.30512 5.19345 7.41693 5.08164C7.52873 4.96984 7.58464 4.83129 7.58464 4.66602C7.58464 4.50074 7.52873 4.3622 7.41693 4.25039C7.30512 4.13859 7.16658 4.08268 7.0013 4.08268C6.83602 4.08268 6.69748 4.13859 6.58568 4.25039C6.47387 4.3622 6.41797 4.50074 6.41797 4.66602C6.41797 4.83129 6.47387 4.96984 6.58568 5.08164C6.69748 5.19345 6.83602 5.24935 7.0013 5.24935ZM7.0013 12.8327C6.19436 12.8327 5.43602 12.6796 4.7263 12.3733C4.01658 12.0671 3.39922 11.6514 2.87422 11.1264C2.34922 10.6014 1.93359 9.98407 1.62734 9.27435C1.32109 8.56463 1.16797 7.80629 1.16797 6.99935C1.16797 6.1924 1.32109 5.43407 1.62734 4.72435C1.93359 4.01463 2.34922 3.39727 2.87422 2.87227C3.39922 2.34727 4.01658 1.93164 4.7263 1.62539C5.43602 1.31914 6.19436 1.16602 7.0013 1.16602C7.80825 1.16602 8.56658 1.31914 9.2763 1.62539C9.98602 1.93164 10.6034 2.34727 11.1284 2.87227C11.6534 3.39727 12.069 4.01463 12.3753 4.72435C12.6815 5.43407 12.8346 6.1924 12.8346 6.99935C12.8346 7.80629 12.6815 8.56463 12.3753 9.27435C12.069 9.98407 11.6534 10.6014 11.1284 11.1264C10.6034 11.6514 9.98602 12.0671 9.2763 12.3733C8.56658 12.6796 7.80825 12.8327 7.0013 12.8327ZM7.0013 11.666C8.30408 11.666 9.40755 11.2139 10.3117 10.3098C11.2159 9.4056 11.668 8.30213 11.668 6.99935C11.668 5.69657 11.2159 4.5931 10.3117 3.68893C9.40755 2.78477 8.30408 2.33268 7.0013 2.33268C5.69852 2.33268 4.59505 2.78477 3.69089 3.68893C2.78672 4.5931 2.33464 5.69657 2.33464 6.99935C2.33464 8.30213 2.78672 9.4056 3.69089 10.3098C4.59505 11.2139 5.69852 11.666 7.0013 11.666Z"
                fill="#7A7A7A" />
            </g>
          </svg>
        </span>
      </h3>
      <!-- Only offered when there is a winner to replace; the server checks the contest is yours. -->
      <button *ngIf="winnersList.length > 0" class="btn btn-sm" (click)="openOverrideModal()"
        style="background: #7C3AED; color: white; border-radius: 8px; padding: 6px 14px; font-size: 13px; display: flex; align-items: center; gap: 6px; border: none;">
        <i class="fa-solid fa-pen-to-square"></i> {{ 'contestDetails.overrideWinner' | translate }}
      </button>
    </div>

    <!-- Winners Table -->
    <nz-table *ngIf="!winnersLoading" #winnersTable [nzData]="winnersList" [nzBordered]="true"
      [nzScroll]="{ x: hasGiftCardCodePrize ? '1530px' : '1170px' }" [nzPageSize]="10" [nzShowPagination]="true">
      <thead>
        <tr>
          <th nzWidth="70px">{{ 'contestDetails.rank' | translate }}</th>
          <th nzWidth="200px">{{ 'contestDetails.participant' | translate }}</th>
          <th nzWidth="170px">{{ 'contestDetails.phoneNumber' | translate }}</th>
          <th nzWidth="110px">{{ 'contestDetails.outcome' | translate }}</th>
          <th nzWidth="200px">{{ 'contestDetails.completionTimestamp' | translate }}</th>
          <th nzWidth="150px">{{ 'contestDetails.prizeStatus' | translate }}</th>
          <th *ngIf="hasGiftCardCodePrize" nzWidth="200px">{{ 'contestDetails.giftCardCodes.codeColumn' | translate }}</th>
          <th *ngIf="hasGiftCardCodePrize" nzWidth="160px">{{ 'contestDetails.giftCardCodes.statusColumn' | translate }}</th>
          <th nzWidth="150px">{{ 'contestDetails.location' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let winner of winnersTable.data; let wi = index">
          <td>
            <span *ngIf="wi === 0" style="font-size: 20px;">🥇</span>
            <span *ngIf="wi === 1" style="font-size: 20px;">🥈</span>
            <span *ngIf="wi === 2" style="font-size: 20px;">🥉</span>
            <span *ngIf="wi > 2" style="font-weight: 600; color: #555;">#{{ wi + 1 }}</span>
          </td>
          <td>
            <div class="participant-info">
              <span>{{ getParticipantName(winner) }}</span>
            </div>
          </td>
          <td><span class="participant-phone" dir="ltr">{{ getParticipantPhone(winner) }}</span></td>
          <td>
            <span class="badge rounded-pill bg-success" style="font-size: 12px;">🏆 {{ 'contestDetails.won' | translate }}</span>
          </td>
          <td>{{ getWinnerCompletionTimestamp(winner) ? (getWinnerCompletionTimestamp(winner) | date: 'medium') : 'N/A'
            }}</td>
          <td>
            <span class="badge rounded-pill" [ngClass]="getWinnerPrizeStatusClass(winner)">
              {{ getWinnerPrizeStatusDisplay(winner) }}
            </span>
          </td>
          <ng-container *ngIf="hasGiftCardCodePrize">
            <td>
              <ng-container *ngIf="getWinnerGiftCards(winner) as codes">
                <code *ngFor="let code of codes; trackBy: trackGiftCardCode" class="gift-card-codes__code d-block" dir="ltr">{{ code.code }}</code>
                <span *ngIf="!codes.length" class="text-muted">—</span>
              </ng-container>
            </td>
            <td>
              <span [ngClass]="giftCardStatusClass(getWinnerGiftCardStatus(winner))">
                {{ 'contestDetails.giftCardCodes.status.' + getWinnerGiftCardStatus(winner) | translate }}
              </span>
            </td>
          </ng-container>
          <td>
            <ng-container *ngIf="winner._end_user?.country || winner.contest?.location as location">
              <span *ngIf="getCountriesArray(location).length > 1" nz-tooltip [nzTooltipTitle]="location">
                {{ getCountriesArray(location)[0] }}...
              </span>
              <span *ngIf="getCountriesArray(location).length === 1">
                {{ location }}
              </span>
              <span *ngIf="getCountriesArray(location).length === 0">
                N/A
              </span>
            </ng-container>
            <span *ngIf="!winner._end_user?.country && !winner.contest?.location">N/A</span>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

</div>

<!-- Admin Override Winner Modal -->
<nz-modal [nzVisible]="overrideModalVisible" [nzTitle]="'contestDetails.overrideWinner' | translate" (nzOnCancel)="closeOverrideModal()"
  [nzFooter]="overrideFooter" nzWidth="600px">
  <ng-container *nzModalContent>
    <div style="padding: 8px 0;">
      <div class="form-group mb-3">
        <label style="font-weight: 600; font-size: 14px; margin-bottom: 6px; display: block;">{{ 'contestDetails.selectParticipant' | translate }}</label>
        <nz-select [(ngModel)]="overrideParticipantId" [nzPlaceHolder]="'contestDetails.selectAParticipant' | translate" nzSize="large"
          style="width: 100%;" [nzShowSearch]="true" [nzOptionOverflowSize]="5">
          <nz-option *ngFor="let p of overrideCandidates" [nzValue]="p.participant_id ?? p.user_id ?? p._end_user?.id ?? p.id"
            [nzLabel]="getParticipantName(p)"></nz-option>
        </nz-select>
      </div>
      <div class="form-group mb-4">
        <label style="font-weight: 600; font-size: 14px; margin-bottom: 6px; display: block;">{{ 'contestDetails.reasonForOverride' | translate }} <span class="text-danger">*</span></label>
        <textarea class="form-control" [(ngModel)]="overrideReason" rows="3"
          [placeholder]="'contestDetails.overrideReasonPlaceholder' | translate" maxlength="500"
          style="border-radius: 8px; resize: vertical;"></textarea>
        <small class="text-muted">{{ overrideReason.length }}/500</small>
      </div>

      <!-- Audit Log -->
      <div *ngIf="overrideAuditLog.length > 0">
        <h6 style="font-weight: 600; margin-bottom: 10px; color: #555;">{{ 'contestDetails.overrideHistory' | translate }}</h6>
        <div *ngFor="let log of overrideAuditLog" class="mb-2 p-3 border rounded"
          style="background: #F9FAFB; border-radius: 8px; font-size: 13px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
            <div>
              <span class="badge bg-secondary" style="margin-right: 6px;">{{ log.participant_name || log.participant_id || 'N/A' }}</span>
              <span *ngIf="log.original_winner_name" style="color: #6B7280; margin-right: 6px;">
                ({{ log.original_winner_name }} &rarr; {{ log.replacement_winner_name || log.participant_name }})
              </span>
              <span style="color: #374151;">{{ log.reason || ('contestDetails.noReasonProvided' | translate) }}</span>
              <div *ngIf="log.actor_name" style="color: #9CA3AF; font-size: 12px; margin-top: 2px;">{{ log.actor_name }}</div>
            </div>
            <small style="color: #9CA3AF; white-space: nowrap;">{{ log.created_at | date: 'short' }}</small>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #overrideFooter>
    <button class="btn btn-light" (click)="closeOverrideModal()" style="border-radius: 8px; margin-right: 8px;">{{ 'common.cancel' | translate }}</button>
    <button class="btn" (click)="submitOverride()" [disabled]="overrideSubmitting || !overrideParticipantId || !overrideReason.trim()"
      style="background: #7C3AED; color: white; border-radius: 8px; border: none;">
      <i *ngIf="overrideSubmitting" class="fa-solid fa-spinner fa-spin" style="margin-right: 4px;"></i>
      {{ overrideSubmitting ? ('contestDetails.submitting' | translate) : ('contestDetails.confirmOverride' | translate) }}
    </button>
  </ng-template>
</nz-modal>

<!-- Participant Levels Drawer -->
<ng-template #levelsDrawerTitle>{{ 'contestDetails.levelProgression' | translate }}{{ selectedParticipant ? ' - ' + getParticipantName(selectedParticipant) : '' }}</ng-template>
<nz-drawer [nzVisible]="levelsDrawerVisible" [nzClosable]="true" [nzWidth]="520" [nzPlacement]="isArabic ? 'left' : 'right'"
  [nzTitle]="levelsDrawerTitle" (nzOnClose)="closeLevelsDrawer()">
  <ng-container *nzDrawerContent>
    <div class="levels-drawer-content">
      <div *ngIf="selectedParticipantLevels.length === 0" class="no-levels">
        <p>{{ 'contestDetails.noLevelsForParticipant' | translate }}</p>
      </div>

      <div class="levels-list">
        <div *ngFor="let level of selectedParticipantLevels; let i = index" class="level-card">
          <div class="level-row">
            <span class="level-label">{{ 'common.name' | translate }}</span>
            <span class="level-value">{{ level.name || (('contestDetails.levels.level' | translate) + ' ' + (i + 1)) }}</span>
          </div>
          <div class="level-row">
            <span class="level-label">{{ 'common.status' | translate }}</span>
            <span class="level-status" [ngClass]="level.status === 'completed' || level.status === 'in_progress' ? level.status : 'pending'">
              {{ level.status === 'completed' ? ('contestDetails.completed' | translate)
                : level.status === 'in_progress' ? ('contestDetails.inProgress' | translate)
                : ('contestDetails.pending' | translate) }}
            </span>
          </div>
          <div class="level-row">
            <span class="level-label">{{ 'contestDetails.points' | translate }}</span>
            <span class="level-value">{{ level.points || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-drawer>

<!-- Level Matrix — Demographic Breakdown Drawer -->
<ng-template #levelDemographicsDrawerTitle>
  {{ (isArabic && selectedLevelMetrics?.arabic_name) ? selectedLevelMetrics.arabic_name : (selectedLevelMetrics?.level_name || ('contestDetails.levelDetails' | translate)) }}
</ng-template>
<nz-drawer [nzVisible]="levelDemographicsDrawerVisible" [nzClosable]="true" [nzWidth]="560" [nzPlacement]="isArabic ? 'left' : 'right'"
  [nzTitle]="levelDemographicsDrawerTitle" (nzOnClose)="closeLevelDemographicsDrawer()">
  <ng-container *nzDrawerContent>
    <div class="level-demographics-content" *ngIf="selectedLevelMetrics as level">
      <div class="level-demographics-summary">
        <div class="summary-row">
          <span class="level-type-badge">{{ getLevelTypeLabel(level) }}</span>
          <div class="summary-stats">
            <span class="stat-chip stat-completed">
              <span class="stat-value">{{ level.completed_count ?? 0 }}</span>
              <span class="stat-label">{{ 'contestDetails.completed' | translate }}</span>
            </span>
            <span class="stat-chip stat-progress">
              <span class="stat-value">{{ level.in_progress_count ?? 0 }}</span>
              <span class="stat-label">{{ 'contestDetails.inProgress' | translate }}</span>
            </span>
            <span class="stat-chip stat-not-started">
              <span class="stat-value">{{ level.not_started_count ?? 0 }}</span>
              <span class="stat-label">{{ 'contestDetails.notStarted' | translate }}</span>
            </span>
          </div>
        </div>
        <div class="completion-rate-row">
          <div class="completion-rate-info">
            <span class="completion-rate-label">{{ 'contestDetails.completionRate' | translate }}</span>
            <span class="completion-rate-value">{{ (level.completion_rate ?? 0) | number:'1.0-1' }}%</span>
          </div>
          <div class="progress-cell">
            <div class="progress">
              <div class="progress-fill"
                [style.width.%]="(level.completion_rate ?? 0) > 100 ? 100 : (level.completion_rate ?? 0)"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="demographic-section" *ngFor="let section of getDemographicSections(level)">
        <div class="demographic-section-header">
          <h4><i class="fa-solid" [ngClass]="section.icon"></i> {{ section.title }}</h4>
          <span class="section-count" *ngIf="section.rows.length">
            {{ section.rows.length < section.totalCount
              ? ('contestDetails.topOf' | translate: { shown: section.rows.length, total: section.totalCount })
              : (section.rows.length + ' ' + (section.rows.length === 1 ? ('contestDetails.group' | translate) : ('contestDetails.groups' | translate))) }}
          </span>
        </div>
        <div class="demographic-table-wrap" *ngIf="section.rows.length; else noBreakdownData">
          <table class="demographic-table">
            <thead>
              <tr>
                <th>{{ section.dimensionLabel }}</th>
                <th class="num">{{ 'contestDetails.notStarted' | translate }}</th>
                <th class="num">{{ 'contestDetails.inProgress' | translate }}</th>
                <th class="num">{{ 'contestDetails.completed' | translate }}</th>
                <th class="num">{{ 'contestDetails.total' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of section.rows">
                <td class="row-label">{{ row.label }}</td>
                <td class="num muted">{{ row.not_started }}</td>
                <td class="num muted">{{ row.in_progress }}</td>
                <td class="num completed-cell">{{ row.completed }}</td>
                <td class="num total-cell">{{ row.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noBreakdownData>
          <p class="text-muted no-data">{{ 'contestDetails.noDataAvailable' | translate }}</p>
        </ng-template>
      </div>
    </div>
  </ng-container>
</nz-drawer>

<!-- Participants Filter Modal -->
<app-filter-modal [(isVisible)]="filterModalVisible" [config]="filterConfig" [modalTitle]="'contestDetails.filterParticipants' | translate"
  [initialFilters]="currentFilters" (filtersApplied)="onFiltersApplied($event)"
  (filtersReset)="onFiltersReset()"></app-filter-modal>
